<template lang="pug">
    div.fluid.ma-0.pa-0.fill-height
        template(v-if="renderCallScreen")
            AcceptIncomingCallDialog(
                v-if="acceptIncomingCallDialog && !isSupervisor"
                :accept-incoming-call="acceptIncomingCall"
                :decline-incoming-call="declineIncomingCall"
                :pending-incoming-call="pendingIncomingCall"
            )

            AcceptCallTransferDialog(
                v-else-if="acceptCallTransferDialog && !isSupervisor"
                :accept-call-transfer="acceptCallTransfer"
                :decline-call-transfer="declineCallTransfer"
                :pending-call-transfer="pendingCallTransfer"
            )

            AcceptSavedPlaceDialog(
                v-else-if="acceptSavedPlaceDialog && !isSupervisor"
                :accept-saved-place-call="acceptSavedPlaceCall",
                :decline-saved-place-call="declineSavedPlaceCall",
                :pending-saved-place-in-line-call="pendingSavedPlaceCall",
            )

            .pa-md-4.brown.lighten-5(style="height: 100vh;" v-else)
                .text-center(v-if="isLoading")
                    v-progress-circular(
                        :size='100'
                        :width='10'
                        color='var(--volie-blue)'
                        indeterminate
                        style="margin-top: 100px;"
                    )
                NoLoggedInQueues(
                    v-else-if="renderNoLoggedInQueues"
                )

                NoCurrentCustomer(
                    v-else-if="renderNoCurrentCustomer"
                    text="We will send you a customer as soon as a call comes in"
                    :calls-waiting="callsWaiting"
                    communication-type="Phone"
                    :enter-manual-mode="enterManualMode"
                    :exit-manual-mode="exitManualMode"
                    :has-logged-in-queues="hasLoggedInQueues"
                    :is-manual-mode="isManualMode"
                    :organization-users="organizationUsers"
                )

                div(v-else)
                    div(v-if="mainErrorAlert.show" style="margin-top: 2%;")
                        v-alert(type="error")
                            | {{ mainErrorAlert.text }}

                    div(v-else)
                        v-row(dense style="height: 100vh;" ref="phoneContentRow")
                            v-col(cols='12' md='8')
                                CustomerProfile.pa-2(
                                    v-if="validCampaignCustomerActiveID && !isSoftReloading && !isSwitchingCustomer"
                                    v-bind:style="{ height: customerProfileHeight + 'px' }"
                                    :add-saved-communication-disposition="addSavedCommunicationDisposition"
                                    :appointment-is-unique-if-required="appointmentIsUniqueIfRequired"
                                    :auto-assist-data="autoAssistData"
                                    :audio-email-incoming="audioEmailIncoming"
                                    :audio-email-outcoming="audioEmailOutcoming"
                                    :call="call"
                                    :call-failed="callFailed"
                                    :call-id="callId"
                                    :call-transfer="callTransfer"
                                    :campaign-disposition-to-survey="campaignDispositionToSurvey"
                                    :carlie-live-handoff="carlieLiveHandoff"
                                    :communication-manager="communicationManager"
                                    communication-type="Phone"
                                    :complete-campaign-customer-active="completeCampaignCustomerActive"
                                    :create-agent="createAgent"
                                    :create-survey-attempt="createSurveyAttempt"
                                    :current-campaign-customer="currentCampaignCustomer"
                                    :customer-profile-height="customerProfileHeight"
                                    :end-call="endCall"
                                    :end-voice-mail-recording="endVoiceMailRecording"
                                    :finish-save-and-next-overlay="finishSaveAndNextOverlay"
                                    :handle-update-current-campaign-customer="handleUpdateCurrentCampaignCustomer"
                                    :has-auto-assist-data="hasAutoAssistData"
                                    :in-communication-center="true"
                                    :initiate-create-communication-disposition="initiateCreateCommunicationDisposition"
                                    :is-locked-agent-status="isLockedAgentStatus"
                                    :is-manual-mode="isManualMode"
                                    :is-paused-voice-mail-recording="isPausedVoiceMailRecording"
                                    :is-rac-online="isRacOnline"
                                    :is-saved-place-call="isSavedPlaceCall"
                                    :is-supervisor="isSupervisor"
                                    :is-live-dash-inbound-call="isLiveDashInboundCall"
                                    :handle-skipped-campaign-customer="handleSkippedCampaignCustomer"
                                    :missed-call-from-call-screen="missedCallFromCallScreen"
                                    :on-call="onCall"
                                    :open-transfer-dialog="openTransferDialog"
                                    :organization-users="organizationUsers"
                                    :parent-disposition-notes="dispositionNotes"
                                    :pending-saved-place-call="pendingSavedPlaceCall"
                                    :switch-campaign-for-campaign-customer-active="switchCampaignForCampaignCustomerActive"
                                    :reset-campaign-disposition-to-survey="resetCampaignDispositionToSurvey"
                                    :reset-saved-communication-dispositions="resetSavedCommunicationDispositions"
                                    :saved-communication-dispositions="savedCommunicationDispositions"
                                    :set-appointment-is-unique-if-required="setAppointmentIsUniqueIfRequired"
                                    :set-campaign-dispositions="setCampaignDispositions"
                                    :set-change-on-current-campaign-customer="setChangeOnCurrentCampaignCustomer"
                                    :set-communication-manager="setCommunicationManager"
                                    :is-communication-manager-set="isCommunicationManagerSet"
                                    :set-integration-customer-sid="setIntegrationCustomerSid"
                                    :set-is-okay-to-create-communication-disposition="setIsOkayToCreateCommunicationDisposition"
                                    :set-is-okay-to-save-and-next="setIsOkayToSaveAndNext"
                                    :set-is-okay-to-survey-saved-disposition="setIsOkayToSurveySavedDisposition"
                                    :set-selected-campaign-disposition="setSelectedCampaignDisposition"
                                    :show-snackbar="showSnackbar"
                                    :start-force-start-next-dial="startForceStartNextDial"
                                    :start-save-and-next="startSaveAndNext"
                                    :start-switch-customer="startSwitchCustomer"
                                    source="communication_center"
                                    :switch-organization-for-campaign-customer-active="switchOrganizationForCampaignCustomerActive"
                                    :sync-disposition-notes="syncDispositionNotes"
                                    :voice-mail-recording="voiceMailRecording"
                                    view="call_screen"
                                )

                                CustomerSearchCreate(
                                    v-else-if="validCampaignID"
                                    v-bind:style="{ height: customerProfileHeight + 'px' }"
                                    communication-type="Phone"
                                    :auto-assist-data="autoAssistData"
                                    :begin-manual-mode-outbound-dial-while-already-in-manual-mode="beginManualModeOutboundDialWhileAlreadyInManualMode"
                                    :call="call"
                                    :call-failed="callFailed"
                                    :call-id="callId"
                                    :cancel-switch-customer="stopSwitchCustomer"
                                    :carlie-live-handoff="carlieLiveHandoff"
                                    :current-campaign="currentCampaign"
                                    :current-campaign-customer="currentCampaignCustomer"
                                    :card-height="customerProfileHeight"
                                    :create-agent="createAgent"
                                    :create-survey-attempt="createSurveyAttempt"
                                    :end-call="endCall"
                                    :end-voice-mail-recording="endVoiceMailRecording"
                                    :finish-save-and-next-overlay="finishSaveAndNextOverlay"
                                    enrollment-purpose="return_call"
                                    :force-customer="forceCustomer"
                                    :force-validated-outbound-number="forceValidatedOutboundNumber"
                                    :has-auto-assist-data="hasAutoAssistData"
                                    :initial-address="initialAddress"
                                    :initial-email-address="initialEmailAddress"
                                    :initial-first-name="initialFirstName"
                                    :initial-last-name="initialLastName"
                                    :initial-phone-number="initialPhoneNumber"
                                    :initiate-create-communication-disposition="initiateCreateCommunicationDisposition"
                                    :is-handling-inbound-call="isHandlingInboundCall"
                                    :is-manual-mode="isManualMode"
                                    :is-paused-voice-mail-recording="isPausedVoiceMailRecording"
                                    :is-saved-place-call="isSavedPlaceCall"
                                    :is-supervisor="isSupervisor"
                                    :is-live-dash-inbound-call="isLiveDashInboundCall"
                                    :is-switching-customer="isSwitchingCustomer"
                                    :manual-mode-enroll-as-eligible="manualModeEnrollAsEligible"
                                    :missed-call-from-call-screen="missedCallFromCallScreen"
                                    :new-enrollment-success="newEnrollmentSuccess"
                                    :on-call="onCall"
                                    :open-transfer-dialog="openTransferDialog"
                                    :organization-users="organizationUsers"
                                    :parent-disposition-notes="dispositionNotes"
                                    :saved-place-in-line-call="pendingSavedPlaceCall"
                                    :set-is-okay-to-create-communication-disposition="setIsOkayToCreateCommunicationDisposition"
                                    :set-is-okay-to-save-and-next="setIsOkayToSaveAndNext"
                                    :set-selected-campaign-disposition="setSelectedCampaignDisposition"
                                    :show-snackbar="showSnackbar"
                                    :start-force-start-next-dial="startForceStartNextDial"
                                    :start-save-and-next="startSaveAndNext"
                                    :switch-customer-for-campaign-customer-active="switchCustomerForCampaignCustomerActive"
                                    :sync-disposition-notes="syncDispositionNotes"
                                    :voice-mail-recording="voiceMailRecording"
                                )

                            v-col(cols='6' md='4')
                                IncomingDetails.no-padding(
                                    :calls-waiting="callsWaiting"
                                )

                                Softphone.no-padding(
                                    :audio-phone-device-connect="audioPhoneDeviceConnect"
                                    :audio-phone-device-dtmf0="audioPhoneDeviceDtmf0"
                                    :audio-phone-device-dtmf1="audioPhoneDeviceDtmf1"
                                    :audio-phone-device-dtmf2="audioPhoneDeviceDtmf2"
                                    :audio-phone-device-dtmf3="audioPhoneDeviceDtmf3"
                                    :audio-phone-device-dtmf4="audioPhoneDeviceDtmf4"
                                    :audio-phone-device-dtmf5="audioPhoneDeviceDtmf5"
                                    :audio-phone-device-dtmf6="audioPhoneDeviceDtmf6"
                                    :audio-phone-device-dtmf7="audioPhoneDeviceDtmf7"
                                    :audio-phone-device-dtmf8="audioPhoneDeviceDtmf8"
                                    :audio-phone-device-dtmf9="audioPhoneDeviceDtmf9"
                                    :audio-phone-device-dtmf-hash="audioPhoneDeviceDtmfHash"
                                    :audio-phone-device-dtmf-star="audioPhoneDeviceDtmfStar"
                                    :audio-phone-device-disconnect="audioPhoneDeviceDisconnect"
                                    :audio-phone-device-ringing="audioPhoneDeviceRinging"
                                    :call-failed="callFailed"
                                    :communication-manager="communicationManager"
                                    :complete-attempt-for-internal-transfer="completeAttemptForInternalTransfer"
                                    :create-agent="createAgent"
                                    :current-campaign-customer="currentCampaignCustomer"
                                    :force-call="forceCall"
                                    :force-conference="forceConference"
                                    :force-end-call="forceEndCall"
                                    :force-start-next-dial="forceStartNextDial"
                                    :force-transfer-dialog="forceTransferDialog"
                                    :force-web-rtc-participant="forceWebRtcParticipant"
                                    :force-web-rtc-session="forceWebRtcSession"
                                    :force-validated-outbound-number="forceValidatedOutboundNumber"
                                    :enter-manual-mode="enterManualMode"
                                    :exit-manual-mode="exitManualMode"
                                    :has-logged-in-queues="hasLoggedInQueues"
                                    :incoming-phone-number="currentCampaignCustomer?.incoming_phone_number"
                                    :is-barge="isBarge"
                                    :is-coach="isCoach"
                                    :is-listen="isListen"
                                    :is-live-dash-inbound-call="isLiveDashInboundCall"
                                    :is-manual-mode="isManualMode"
                                    :is-non-browser-device="isNonBrowserDevice"
                                    :is-okay-to-save-and-next="isOkayToSaveAndNext"
                                    :is-paused-voice-mail-recording="isPausedVoiceMailRecording"
                                    :is-wrap-up-blocking-dial="isWrapUpBlockingDial"
                                    :on-vin-login-decision-required="onVinLoginDecisionRequired"
                                    :missed-call-from-call-screen="missedCallFromCallScreen"
                                    :organization-users="organizationUsers"
                                    :pending-saved-place-call="pendingSavedPlaceCall"
                                    :remove-force-transfer-dialog="removeForceTransferDialog"
                                    :retry-dial-intent-token="retryDialIntentToken"
                                    :save-and-next-action="saveAndNextAction"
                                    :clear-dial-intent="clearDialIntent"
                                    :selected-campaign-disposition="selectedCampaignDisposition"
                                    :set-call="setCall"
                                    :set-on-call="setOnCall"
                                    :set-call-failed="setCallFailed"
                                    :should-skip-wrap-up-for-get-next-advance="shouldSkipWrapUpForGetNextAdvance"
                                    :start-save-and-next="startSaveAndNext"
                                    :voice-mail-recording="voiceMailRecording"
                                    :toggle-freeze-agent-status-push="toggleFreezeAgentStatusPush"
                                    :freeze-agent-status-push="freezeAgentStatusPush"
                                    :vin-login-decision-pending="vinLoginDecisionPending"
                                )

                                Survey.pa-2(
                                    v-if="!isSoftReloading"
                                    v-bind:style="{ height: surveyHeight + 'px' }"
                                    :campaign-customer-id="currentCampaignCustomer?.campaign_customer_id"
                                    :campaign-id="currentCampaignCustomer?.campaign_id"
                                    :parent-disposition-notes="dispositionNotes"
                                    :set-survey="setSurvey"
                                    :sync-disposition-notes="syncDispositionNotes"
                                    :survey-height="surveyHeight"
                                )

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState  from "@/store";

    // Components
    import AcceptSavedPlaceDialog from '@/components/communication_center/phone/accept_saved_place_dialog.vue';
    import AcceptCallTransferDialog from '@/components/communication_center/phone/accept_call_transfer_dialog.vue';
    import AcceptIncomingCallDialog from '@/components/communication_center/phone/accept_incoming_call_dialog.vue';
    import CustomerProfile from '@/components/communication_center/shared/customer_profile.vue';
    import CustomerSearchCreate from '@/components/communication_center/shared/customer_search_create.vue';
    import IncomingDetails from '@/components/communication_center/phone/incoming_details.vue';
    import NoCurrentCustomer from '@/components/communication_center/shared/no_current_customer.vue';
    import NoLoggedInQueues from '@/components/communication_center/shared/no_logged_in_queues.vue';
    import Softphone from '@/components/communication_center/phone/softphone.vue';
    import Survey from '@/components/communication_center/phone/survey.vue';

    // Data
    import { WRAP_UP_AGENT_STATUSES } from '@/constants/agent_statuses';
    import {
        AcceptCallTransfer,
        AcceptIncomingCall,
        AcceptSavedPlaceCall,
        AssignNextInboundCall,
        AssignNextInboundCallTransfer,
        AssignNextMissedCall,
        AssignReadyCampaignCustomers,
        AssignNextSavedPlaceInLine,
        CreateSurveyAttempt,
        DeclineCallTransfer,
        DeclineIncomingCall,
        DeclineSavedPlaceCall,
        GetAutoAssistantRequests,
        ReclaimNextInboundOffer,
        SwitchCampaignForCampaignCustomerActive,
        StartVoiceMailRecording,
        UpdateAutoAssistantRequest,
        UpdateCampaignCustomerActive,
        SwitchCustomerForCampaignCustomerActive,
        SwitchOrganizationForCampaignCustomerActive,
        VerifyCurrentAgent,
        isAssignNextCallTransferEmpty,
        isAssignNextInboundCallEmpty,
        isAssignNextSavedPlaceInLineEmpty,
    } from "@/data";

    // Helpers
    import { debounce } from '@/helpers/coroutine';
    import { UpdateAssignedCustomerFromCustomerCommunicationManager } from "@/helpers/customer";
    import { applyIncomingTotalCommunicationDispositions, getDenotionPriorities } from "@/helpers/dispositions";

    const QUEUED_PENDING_INCOMING_CALL_TTL_MS = 30000;
    // VE-10478: a transfer offer held past its TTL keeps extending while the agent is still on the
    // call it came from (A→B→A), because a pending transfer is invisible to every other agent until
    // it is declined back to queued. Capped so that hold cannot outlive a long call.
    const QUEUED_PENDING_CALL_TRANSFER_MAX_HOLD_MS = 90000;
    const RECOVER_OFFERING_CALL_ACCEPT_UI_DELAY_MS = 3000;
    // VE-10475: one-shot from accept. Cancelled when the call hydrates. Do not use currentAgentTimer —
    // that kept firing during live calls and forced Available → Pause.
    const STUCK_ACCEPTED_CALL_TIMEOUT_MS = 60000;
    // VE-10477: Accept* fetch has no timeout. If it never settles, the processing flag
    // blocks get-next and inbound recovery until refresh. Cancelled when the request settles.
    const ACCEPT_IN_FLIGHT_TIMEOUT_MS = 60000;
    // Offer recovery (VE-10188 inbound; VE-10478 transfer + saved-place):
    // - currentAgent watcher → schedule recover (3s debounce after Offering Call / Offering Saved Place Call)
    // - currentAgentTimer (30s) → recoverOfferingCallAcceptUI / recoverOfferingSavedPlaceCallAcceptUI
    // - onAssignedCampaignCustomerRefresh → schedule recover (blocks get-next steal)
    // - handleAssignNext*Result / flushQueuedPending* → queue or open; flush reclaims via API
    // Guards: recover*InFlight, flushQueued*InFlight, isBusyWithLiveOrAcceptingCall
    // Accepted-call recovery (VE-10473 / VE-10475): the offer is already consumed, so these only free the agent
    // - armStuckAcceptedCallTimeout (60s, accept-scoped) → recoverAfterStuckAcceptedCallHydration
    // - currentAgentTimer (30s) → recoverAfterStuckAcceptedCall (no-op while isHandlingInboundCall)
    // - onAssignedCampaignCustomerRefresh / resyncScreenForInternetLoss → isCurrentAgentStatusPossibleSuspicious
    // Accept-inflight timeout (VE-10477): armAcceptInFlightTimeout (60s) → recoverAfterStuckAcceptInFlight

    export default Vue.extend({
        data() {
            return {
                autoAssistData: {},
                autoAssistantRequestTimeoutId: null,
                acceptCallTransferDialog: false,
                acceptInFlightGeneration: 0,
                acceptInFlightTimeoutId: null,
                acceptIncomingCallDialog: false,
                acceptSavedPlaceDialog: false,
                appointmentIsUniqueIfRequired: true,
                isProcessingAcceptCallTransfer: false,
                isProcessingAcceptIncomingCall: false,
                isProcessingAcceptSavedPlaceCall: false,
                bus: VolieState.websocketClient().eventBus(),
                assignedInProgressCampaignCustomerDeployments: [],
                call: null,
                callFailed: false,
                callTransfer: null,
                campaignCustomers: [],
                campaignDispositions: [],
                campaignDispositionToSurvey: null,
                // The Carlie AI communication behind an accepted live transfer, with the details the
                // offer already fetched so the Carlie tab opens without waiting on them again.
                carlieLiveHandoff: null,
                communicationManager: null,
                // An analysis pushed while the accept was still in flight, applied once the live handoff is set.
                earlyCarlieAnalysisUpdate: null,
                isCommunicationManagerSet: false,
                contentRowHeight: null,
                currentCampaign: null, // only necessary for inbound and manual mode calls
                currentCampaignCustomer: null,
                customerProfileHeight: null,
                dispositionNotes: null,
                dispositionPrioritiesById: {},
                firstRequestSent: false, // AutoAssistDataFetch
                forceCall: null,
                forceConference: null,
                forceDestroy: false,
                forceEndCall: false,
                forceStartNextDial: false,
                forceTransferDialog: null,
                forceWebRtcParticipant: null,
                forceWebRtcSession: null,
                getNextAvailableMintPending: false,
                getNextChainId: 0,
                getNextInFlight: false,
                getNextInFlightTimeoutId: null,
                getNextPending: false,
                initialAddress: null,
                initialEmailAddress: null,
                initialFirstName: null,
                initialLastName: null,
                initialPhoneNumber: null,
                initiateCreateCommunicationDisposition: false,
                isHandlingInboundCall: false,
                isLoading: false,
                isManualMode: false,
                isNonBrowserDevice: false,
                isOkayToCreateCommunicationDisposition: false,
                isOkayToSaveAndNext: false,
                isOkayToSurveySavedDisposition: false,
                isSavedPlaceCall: false,
                isSoftReloading: false,
                isStartingVoiceMailRecording: false,
                isSwitchingCustomer: false,
                isUpdatingCCActive: false,
                // Remembers Break/Lunch/etc. across Offering Call races so decline restores it instead of Pause (VE-8831).
                // Cleared on any production status except the two offer statuses (manual outbound must not keep it).
                intendedNonProductionStatusName: null,
                mainErrorAlert: {},
                manualModeCampaign: null,
                manualModeEnrollAsEligible: false,
                onCall: false,
                pendingSavedPlaceCall: null,
                pendingCallTransfer: null,
                pendingIncomingCall: null,
                queuedPendingCallTransfer: null,
                queuedPendingCallTransferId: null,
                queuedPendingCallTransferQueuedAt: null,
                queuedPendingCallTransferTtlTimeoutId: null,
                queuedPendingIncomingCall: null,
                queuedPendingIncomingCallCcqId: null,
                queuedPendingIncomingCallQueuedAt: null,
                queuedPendingIncomingCallTtlTimeoutId: null,
                queuedPendingSavedPlaceCall: null,
                queuedPendingSavedPlaceCallId: null,
                queuedPendingSavedPlaceCallQueuedAt: null,
                queuedPendingSavedPlaceCallTtlTimeoutId: null,
                flushQueuedPendingCallTransferInFlight: false,
                flushQueuedPendingIncomingCallInFlight: false,
                flushQueuedPendingSavedPlaceCallInFlight: false,
                recoverOfferingCallAcceptUiTimeoutId: null,
                recoverOfferingCallInFlight: false,
                recoverOfferingSavedPlaceCallAcceptUiTimeoutId: null,
                recoverOfferingSavedPlaceCallInFlight: false,
                retryDialIntentToken: 0,
                saveAndNextAction: null,
                saveAndNextWrapUpSkipCallId: 0,
                savedCommunicationDispositions: [],
                selectedCampaignDisposition: null,
                stuckAcceptedCallTimeoutId: null,
                survey: null,
                surveyHeight: null,
                voiceMailRecording: null,
            }
        },
        methods: {
            acceptCallTransfer() {

                if (this.isProcessingAcceptCallTransfer) {
                    return;
                }

                // Verify
                if (!(this.pendingCallTransfer?.call_transfer?.id > 0)) {
                    return;
                }

                if (!this.acceptCallTransferDialog) {
                    return;
                }

                this.isProcessingAcceptCallTransfer = true;
                this.acceptInFlightGeneration += 1;
                const generation = this.acceptInFlightGeneration;
                this.armAcceptInFlightTimeout(generation);

                // Close dialog
                this.closeAcceptCallTransferDialog();

                // Init
                const options = {
                    attempt_key: this.currentAgent?.attempt_key,
                }
                // Accept
                AcceptCallTransfer(this.pendingCallTransfer?.call_transfer?.id, options).then((response) => {
                    if (generation !== this.acceptInFlightGeneration) {
                        return;
                    }
                    this.clearAcceptInFlightTimeout();
                    if (response?.Data?.Ok === true) {
                        this.acceptCallTransferSuccess(response.Data);
                    } else {
                        this.isProcessingAcceptCallTransfer = false;
                        // VE-10476: a stale transfer offer blocks get-next the same way VE-10473 did for inbound.
                        this.pendingCallTransfer = null;
                        this.showSnackbar("error", "Call transfer was no longer available");
                        this.finishGetNextChain();
                        this.getNext(null); // on failure, go and get the next call
                    }
                }).catch(() => {
                    if (generation !== this.acceptInFlightGeneration) {
                        return;
                    }
                    this.clearAcceptInFlightTimeout();
                    this.isProcessingAcceptCallTransfer = false;
                    this.pendingCallTransfer = null;
                    this.showSnackbar("error", "An error occurred while accepting the call transfer");
                    this.finishGetNextChain();
                    this.getNext(null);
                });
            },
            acceptCallTransferSuccess(data) {

                // Verify
                if (!(this.pendingCallTransfer?.call_transfer?.id > 0) || !(this.pendingCallTransfer?.call_transfer?.campaign_id > 0)) {
                    this.isProcessingAcceptCallTransfer = false;
                    this.pendingCallTransfer = null;
                    // Accept already succeeded server-side — do not getNext (could double-offer).
                    this.finishGetNextChain();
                    return;
                }

                this.clearIntendedNonProductionStatus();

                // Set current back to null
                this.currentCampaign = null;
                this.currentCampaignCustomer = null;
                this.voiceMailRecording = null;
                this.pendingSavedPlaceCall = null;
                this.isSavedPlaceCall = false;
                this.resetCurrentCampaignCustomerDefaults(false);
                // Claim ownership immediately after reset so getNext/refresh cannot run before nextTick hydration.
                this.isHandlingInboundCall = true;
                this.armStuckAcceptedCallTimeout();

                // Run in next tick so screen resets properly
                Vue.nextTick(() => {
                    this.isProcessingAcceptCallTransfer = false;

                    // Set current campaign
                    this.currentCampaign = {
                        account_id: this.pendingCallTransfer.assigned_campaign_customer.account_id,
                        campaign_id: this.pendingCallTransfer.assigned_campaign_customer.campaign_id,
                        organization_id: this.pendingCallTransfer.assigned_campaign_customer.organization_id,
                        organization_time_zone_id: null,
                        campaign_name: this.pendingCallTransfer.assigned_campaign_customer.campaign_name,
                        organization_name: this.pendingCallTransfer.assigned_campaign_customer.organization_name,
                    }

                    // set current campaign customer active
                    this.currentCampaignCustomer = { ...this.pendingCallTransfer.assigned_campaign_customer };

                    // Add to slice
                    // todo - determine if we should do this for manual calls too
                    this.campaignCustomers.unshift(this.currentCampaignCustomer);

                    // Set call
                    this.callTransfer = { ...this.pendingCallTransfer.call_transfer };
                    this.forceCall = { ...this.pendingCallTransfer.customer_call };
                    this.forceConference = { ...this.pendingCallTransfer.conference };

                    // Set web rtc if present
                    if (data?.web_rtc_session?.id > 0 && data?.web_rtc_participant?.id > 0) {
                        this.forceWebRtcSession = { ...data.web_rtc_session };
                        this.forceWebRtcParticipant = { ...data.web_rtc_participant };
                    }

                    // Do not clear pendingCallTransfer here - renderNoCurrentCustomer needs it to keep
                    // the call screen and softphone mounted for callers with no campaign customer active

                    // If current cc already has a cc_active_ID, then move into "in progress" status
                    if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                        this.moveCampaignCustomerActiveToInProgress();
                    } else {

                        // auto search for customers based on phone number
                        this.initialPhoneNumber = this.forceCall?.from_number;
                    }

                    // Resize window
                    Vue.nextTick(() => {
                        this.handleWindowResize();
                    });
                });
            },
            acceptIncomingCall(carlieDetails) {

                // Prevent multiple simultaneous calls
                if (this.isProcessingAcceptIncomingCall) {
                    return;
                }

                // Verify
                if (!(this.pendingIncomingCall?.call_communication_queue?.call_communication_queue_id > 0)) {
                    return;
                }

                // Verify dialog is open - if not, abort
                if (!this.acceptIncomingCallDialog) {
                    return;
                }

                // Set processing flag
                this.isProcessingAcceptIncomingCall = true;
                this.acceptInFlightGeneration += 1;
                const generation = this.acceptInFlightGeneration;
                this.armAcceptInFlightTimeout(generation);

                // Close dialog
                this.closeAcceptIncomingCallDialog();

                // Init
                const options = {
                    attempt_key: this.currentAgent?.attempt_key,
                }

                // Accept
                AcceptIncomingCall(this.pendingIncomingCall?.call_communication_queue?.call_communication_queue_id, options).then((response) => {
                    if (generation !== this.acceptInFlightGeneration) {
                        return;
                    }
                    this.clearAcceptInFlightTimeout();
                    if (response?.Data?.ok === true) {
                        this.acceptIncomingCallSuccess(response.Data, carlieDetails);
                    } else {
                        this.isProcessingAcceptIncomingCall = false;
                        // VE-10473: a stale offer blocks every Offering Call recovery path.
                        this.pendingIncomingCall = null;
                        this.showSnackbar("error", "Inbound call was no longer available");
                        this.finishGetNextChain();
                        this.getNext(null); // on failure, go and get the next call
                    }
                }).catch((error) => {
                    if (generation !== this.acceptInFlightGeneration) {
                        return;
                    }
                    this.clearAcceptInFlightTimeout();
                    this.isProcessingAcceptIncomingCall = false;
                    this.pendingIncomingCall = null;
                    this.showSnackbar("error", "An error occurred while accepting the call");
                    this.finishGetNextChain();
                    this.getNext(null); // on error, go and get the next call
                });
            },
            acceptIncomingCallSuccess(data, carlieDetails) {

                // Verify
                if (!(this.pendingIncomingCall?.call_communication_queue?.call_communication_queue_id > 0) || !(this.pendingIncomingCall?.assigned_campaign_customer?.campaign_id > 0)) {
                    this.isProcessingAcceptIncomingCall = false;
                    this.pendingIncomingCall = null;
                    // Accept already succeeded server-side — do not getNext (could double-offer).
                    this.finishGetNextChain();
                    return;
                }

                this.clearIntendedNonProductionStatus();

                this.isNonBrowserDevice = data?.is_non_browser_device === true;

                // Set current back to null
                this.currentCampaign = null;
                this.currentCampaignCustomer = null;
                this.voiceMailRecording = null;
                this.pendingSavedPlaceCall = null;
                this.isSavedPlaceCall = false;
                this.resetCurrentCampaignCustomerDefaults(false);
                // Claim ownership immediately after reset so getNext/refresh cannot run before nextTick hydration.
                this.isHandlingInboundCall = true;
                this.armStuckAcceptedCallTimeout();

                const carlieAiCommunicationId = this.pendingIncomingCall?.carlie?.ai_communication_id;
                if (carlieAiCommunicationId > 0) {
                    const early = this.earlyCarlieAnalysisUpdate?.ai_communication_id === carlieAiCommunicationId ? this.earlyCarlieAnalysisUpdate : null;
                    this.carlieLiveHandoff = { aiCommunicationId: carlieAiCommunicationId, analysis: early?.analysis || null, details: carlieDetails || null };
                }
                this.earlyCarlieAnalysisUpdate = null;

                // Run in next tick so screen resets properly
                Vue.nextTick(() => {
                    this.isProcessingAcceptIncomingCall = false;

                    // Set current campaign
                    this.currentCampaign = {
                        account_id: this.pendingIncomingCall.assigned_campaign_customer.account_id,
                        campaign_id: this.pendingIncomingCall.assigned_campaign_customer.campaign_id,
                        organization_id: this.pendingIncomingCall.assigned_campaign_customer.organization_id,
                        organization_time_zone_id: null,
                        campaign_name: this.pendingIncomingCall.assigned_campaign_customer.campaign_name,
                        organization_name: this.pendingIncomingCall.assigned_campaign_customer.organization_name,
                    }

                    // set current campaign customer active
                    this.currentCampaignCustomer = { ...this.pendingIncomingCall.assigned_campaign_customer };

                    // Add to slice
                    // todo - determine if we should do this for manual calls too
                    this.campaignCustomers.unshift(this.currentCampaignCustomer);

                    // Set call
                    this.forceCall = { ...this.pendingIncomingCall.call };
                    this.forceConference = { ...this.pendingIncomingCall.conference };

                    // Set web rtc if present
                    if (data?.web_rtc_session?.id > 0 && data?.web_rtc_participant?.id > 0) {
                        this.forceWebRtcSession = { ...data.web_rtc_session };
                        this.forceWebRtcParticipant = { ...data.web_rtc_participant };
                    }

                    // Do not clear pendingIncomingCall here - renderNoCurrentCustomer needs it to keep
                    // the call screen and softphone mounted for callers with no campaign customer active

                    // If current cc already has a cc_active_ID, then move into "in progress" status
                    if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                        this.moveCampaignCustomerActiveToInProgress(true);
                    } else {

                        // auto search for customers based on phone number
                        this.initialPhoneNumber = this.forceCall?.from_number;
                    }

                    // Resize window
                    Vue.nextTick(() => {
                        this.handleWindowResize();
                    });
                });
            },
            acceptSavedPlaceCall() {
                if (this.isProcessingAcceptSavedPlaceCall) {
                    return;
                }

                // Verify
                if (!(this.pendingSavedPlaceCall?.scheduled_communication_id > 0)) {
                    return;
                }

                // Verify dialog is open - if not, abort
                if (!this.acceptSavedPlaceDialog) {
                    return;
                }

                this.isProcessingAcceptSavedPlaceCall = true;
                this.acceptInFlightGeneration += 1;
                const generation = this.acceptInFlightGeneration;
                this.armAcceptInFlightTimeout(generation);

                // Close dialog
                this.closeAcceptSavedPlaceDialog();

                // Init
                const options = {
                    attempt_key: this.currentAgent?.attempt_key,
                }

                // Accept
                AcceptSavedPlaceCall(this.pendingSavedPlaceCall?.scheduled_communication_id, options).then((response) => {
                    if (generation !== this.acceptInFlightGeneration) {
                        return;
                    }
                    this.clearAcceptInFlightTimeout();
                    if (response?.Data?.ok === true) {
                        this.acceptSavedPlaceCallSuccess();
                    } else {
                        this.isProcessingAcceptSavedPlaceCall = false;
                        this.showSnackbar("error", "Saved place in line call was no longer available");
                        this.finishGetNextChain();
                        this.getNext(null); // on failure, go and get the next call
                    }
                }).catch(() => {
                    if (generation !== this.acceptInFlightGeneration) {
                        return;
                    }
                    this.clearAcceptInFlightTimeout();
                    this.isProcessingAcceptSavedPlaceCall = false;
                    this.showSnackbar("error", "An error occurred while accepting the saved place call");
                    this.finishGetNextChain();
                    this.getNext(null);
                });
            },
            acceptSavedPlaceCallSuccess() {

                // Verify
                if (!((this.pendingSavedPlaceCall?.call_communication_queue?.call_communication_queue_id > 0) || (this.pendingSavedPlaceCall?.assigned_campaign_customer?.campaign_id > 0))) {
                    this.isProcessingAcceptSavedPlaceCall = false;
                    // Accept already succeeded server-side — do not getNext (could double-offer).
                    this.finishGetNextChain();
                    return;
                }

                this.clearIntendedNonProductionStatus();

                // Set current back to null
                this.currentCampaign = null;
                this.currentCampaignCustomer = null;
                this.voiceMailRecording = null;
                this.resetCurrentCampaignCustomerDefaults(false);
                // Claim ownership immediately after reset so getNext/refresh cannot run before nextTick hydration.
                this.isHandlingInboundCall = true;
                this.armStuckAcceptedCallTimeout();

                // Run in next tick so screen resets properly
                Vue.nextTick(() => {
                    this.isProcessingAcceptSavedPlaceCall = false;

                    // set bool so call screen shows banner
                    this.isSavedPlaceCall = true;

                    // Set current campaign
                    this.currentCampaign = {
                        account_id: this.pendingSavedPlaceCall.assigned_campaign_customer.account_id,
                        campaign_id: this.pendingSavedPlaceCall.assigned_campaign_customer.campaign_id,
                        organization_id: this.pendingSavedPlaceCall.assigned_campaign_customer.organization_id,
                        organization_time_zone_id: null,
                        campaign_name: this.pendingSavedPlaceCall.assigned_campaign_customer.campaign_name,
                        organization_name: this.pendingSavedPlaceCall.assigned_campaign_customer.organization_name,
                    }

                    // set current campaign customer active
                    this.currentCampaignCustomer = { ...this.pendingSavedPlaceCall.assigned_campaign_customer };

                    // add to array
                    this.campaignCustomers.unshift(this.currentCampaignCustomer);

                    // If current cc already has a cc_active_ID, then move into "in progress" status
                    if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                        this.moveCampaignCustomerActiveToInProgress();
                    } else {

                        // auto search for customers based on phone number
                        this.initialPhoneNumber = this.pendingSavedPlaceCall.call?.from_number;
                    }

                    this.startForceStartNextDial();

                    // Resize window
                    Vue.nextTick(() => {
                        this.handleWindowResize();
                    });

                });
            },
            addSavedCommunicationDisposition(disposition) {
                this.savedCommunicationDispositions.push(disposition);
            },
            assignDispositionPriority(disposition) {
                let priority = 10;
                for (const denotion of getDenotionPriorities()) {
                    if (disposition[denotion.denotes]) {
                        if (denotion.priority < priority) {
                            priority = denotion.priority;
                        }
                    }
                }

                this.dispositionPrioritiesById[disposition.disposition_id] = priority;
            },
            assignNextInboundCall(chainId) {

                if (this.isSupervisor) {
                    this.finishGetNextChain();
                    return;
                }
                // If the current user isn't logged into any queues, no need to run this request
                if (!this.hasLoggedInQueues) {
                    this.mainErrorAlert.show = true;
                    this.mainErrorAlert.text = "Please log into one or more communication queues to get started";
                    this.finishGetNextChain();
                    return;
                }

                // Verify current user has ability to take inbound calls
                if (!this.isInboundEligible) {

                    // Try outbound calls now
                    this.getNext("assignNextInboundCall");
                    return;
                }

                this.isLoading = true;
                AssignNextInboundCall().then((response) => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }

                    // If we don't find an eligible ccq, next look for a missed call
                    if (isAssignNextInboundCallEmpty(response?.Data)) {
                        this.getNext("assignNextInboundCall");
                    } else {
                        this.isLoading = false;
                        this.handleAssignNextInboundCallResult(response.Data);
                    }
                }).catch(() => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }
                    this.getNext("assignNextInboundCall");
                });
            },
            assignNextInboundCallTransfer(chainId) {

                if (this.isSupervisor) {
                    this.finishGetNextChain();
                    return;
                }
                // If the current user isn't logged into any queues, no need to run this request
                if (!this.hasLoggedInQueues) {
                    this.mainErrorAlert.show = true;
                    this.mainErrorAlert.text = "Please log into one or more communication queues to get started";
                    this.finishGetNextChain();
                    return;
                }

                this.isLoading = true;
                AssignNextInboundCallTransfer().then((response) => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }

                    // If we don't find an eligible call transfer, next look for saved place
                    if (isAssignNextCallTransferEmpty(response?.Data)) {
                        this.getNext("assignNextInboundCallTransfer");
                    } else {
                        this.isLoading = false; // only turn off loading if we found an inbound call transfer because we want to keep loading through rest of get next
                        this.handleAssignNextCallTransferResult(response.Data);
                    }
                }).catch(() => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }
                    this.getNext("assignNextInboundCallTransfer");
                });
            },
            assignNextMissedCall(chainId) {

                if (this.isSupervisor) {
                    this.finishGetNextChain();
                    return;
                }

                // If the account doesn't have this enabled, just move on to outbound
                if (!this.isMissedCallEnabled) {
                    this.getNext("assignNextMissedCall");
                    return;
                }

                // If the current user isn't logged into any queues, no need to run this request
                if (!this.hasLoggedInQueues) {
                    this.mainErrorAlert.show = true;
                    this.mainErrorAlert.text = "Please log into one or more communication queues to get started";
                    this.finishGetNextChain();
                    return;
                }

                this.isLoading = true;
                AssignNextMissedCall().then((response) => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }

                    // If we don't find an eligible missed call, next look for an outbound call
                    if (!(response.Data?.voice_mail_recording_id > 0)) {
                        this.getNext("assignNextMissedCall");
                    } else {
                        this.isLoading = false; // only turn off loading if we found a missed call because we want to keep loading through rest of get next
                        // Finish is deferred until StartVoiceMailRecording completes — refresh watchdog.
                        this.armGetNextInFlightTimeout(chainId);
                        this.setVoiceMailRecordingId(response.Data.voice_mail_recording_id, true);
                    }
                }).catch(() => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }
                    this.getNext("assignNextMissedCall");
                });
            },
            assignNextSavedPlaceInLine(chainId) {

                if (this.isSupervisor) {
                    this.finishGetNextChain();
                    return;
                }
                // If the current user isn't logged into any queues, no need to run this request
                if (!this.hasLoggedInQueues) {
                    this.mainErrorAlert.show = true;
                    this.mainErrorAlert.text = "Please log into one or more communication queues to get started";
                    this.finishGetNextChain();
                    return;
                }

                // Verify current user has ability to take inbound calls (even though they have to dial out, this is technically from an inbound call)
                if (!this.isInboundEligible) {

                    // Try outbound calls now (can skip trying inbound, since it would just return the same here)
                    this.getNext("assignNextInboundCall");
                    return;
                }

                this.isLoading = true;
                AssignNextSavedPlaceInLine().then((response) => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }

                    // If we don't find an eligible pending held place, next look for inbound
                    if (isAssignNextSavedPlaceInLineEmpty(response?.Data)) {
                        this.getNext("assignNextSavedPlaceInLine");
                    } else {
                        this.isLoading = false; // only turn off loading if we found an saved place because we want to keep loading through rest of get next
                        this.handleAssignNextSavedPlaceResult(response.Data);
                    }
                }).catch(() => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }
                    this.getNext("assignNextSavedPlaceInLine");
                });
            },
            assignReadyCampaignCustomers(chainId, skipLoading) {
                if (this.isSupervisor) {
                    this.isLoading = false;
                    this.finishGetNextChain();
                    return;
                }
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    this.isLoading = false;
                    this.queueGetNext();
                    this.finishGetNextChain();
                    return;
                }
                // If the current user isn't logged into any queues, no need to run this request
                if (!this.hasLoggedInQueues) {
                    this.mainErrorAlert.show = true;
                    this.mainErrorAlert.text = "Please log into one or more communication queues to get started";
                    this.finishGetNextChain();
                    return;
                }

                // Verify current user has ability to do outbound call
                if (!this.isOutboundEligible) {

                    // Ensure campaign customers are empty and move agent to available
                    this.campaignCustomers = [];

                    // If they aren't already on available, move them to available
                    this.isLoading = false;
                    this.finishGetNextChainAfterAvailableMint(
                        this.currentAgent?.agent_status_name !== "Available"
                    );
                    return;
                }

                const options = {
                    communication_type_name: "Phone",
                    purpose: "default",
                }

                if (!skipLoading) {
                    this.isLoading = true;
                }
                AssignReadyCampaignCustomers(options).then((response) => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }
                    if (!!response.Data && !!response.Data.campaign_customers && response.Data.campaign_customers.length > 0) {
                        this.campaignCustomers = response.Data.campaign_customers;
                        this.findOrSetInProgressCampaignCustomer(chainId);
                    } else {
                        this.isLoading = false;
                        this.campaignCustomers = [];

                        // If the current user's status is not "Available", move them into available
                        // * NOTE * If agent was previously in available status but the campaign enrollment refresh job
                        // causes the "getNext" to rerun automatically while the agent is sitting in available already
                        // then the screen was creating a duplicate available record (without this check)
                        this.finishGetNextChainAfterAvailableMint(
                            this.currentAgent?.agent_status_name !== "Available"
                        );
                    }
                }).catch(() => {
                    if (chainId !== this.getNextChainId) {
                        return;
                    }
                    this.isLoading = false;
                    this.finishGetNextChain();
                });

                return;
            },
            buildCampaignDispositionPriorities() {
                this.dispositionPrioritiesById = {};
                for (const disposition of this.campaignDispositions) {
                    this.assignDispositionPriority(disposition);
                }
            },
            closeAcceptIncomingCallDialog() {
                this.acceptIncomingCallDialog = false;
                // Dialog was part of isBusyWithLiveOrAcceptingCall — retry deferred getNext once settled.
                Vue.nextTick(() => {
                    this.flushGetNextPending();
                    this.flushQueuedOffers();
                });
            },
            closeAcceptCallTransferDialog() {
                this.acceptCallTransferDialog = false;
                Vue.nextTick(() => {
                    this.flushGetNextPending();
                    this.flushQueuedOffers();
                });
            },
            closeAcceptSavedPlaceDialog() {
                this.acceptSavedPlaceDialog = false;
                Vue.nextTick(() => {
                    this.flushGetNextPending();
                    this.flushQueuedOffers();
                });
            },
            completeCampaignCustomerActive() {

                // Init options
                const options = {
                    campaign_customer_active_id: this.currentCampaignCustomer?.campaign_customer_active_id,
                    account_id: this.currentCampaignCustomer?.account_id,
                    status: "completed",
                }

                // Update record in db
                this.updateCampaignCustomerActive(options, false);
            },
            // Statuses where the agent intentionally left production idle (break/lunch/etc.); getNext must not force Available.
            isAgentStatusExcludedFromAutoAvailable() {
                const name = this.currentAgent?.agent_status_name;
                if (!name) {
                    return false;
                }
                return [
                    "Break",
                    "Lunch",
                    "Meeting",
                ].indexOf(name) >= 0;
            },
            // True while accepting an offer or already on/owning a live call context (VE-6502).
            isBusyWithLiveOrAcceptingCall() {
                if (this.onCall || this.isHandlingInboundCall) {
                    return true;
                }
                if (this.isProcessingAcceptIncomingCall || this.isProcessingAcceptCallTransfer || this.isProcessingAcceptSavedPlaceCall) {
                    return true;
                }
                if (this.acceptIncomingCallDialog || this.acceptCallTransferDialog || this.acceptSavedPlaceDialog) {
                    return true;
                }
                if (this.validCallId || this.forceCall?.id > 0) {
                    return true;
                }
                return false;
            },
            // Check if agent is already in a non-production status (Break, Lunch, Meeting, Pause, etc.)
            // Used to prevent race conditions where declining a call would move agent into "Pause" status 
            // after they've gone on break or into a meeting
            isAgentInNonProductionStatus() {
                // status_type 4 = non-production (covers custom account statuses too)
                if (this.currentAgent?.status_type === 4) {
                    return true;
                }
                // Fallback to known status names if status_type not available
                const name = this.currentAgent?.agent_status_name;
                return ["Break", "Lunch", "Meeting", "Pause", "Do Not Disturb"].indexOf(name) >= 0;
            },
            // Intentional non-production (excludes system Pause) — used to track/restore Break across offer races.
            isIntentionalNonProductionAgentStatus(agent) {
                if (!agent) {
                    return false;
                }
                const name = agent.agent_status_name;
                if (!name || name === "Pause") {
                    return false;
                }
                if (agent.status_type === 4) {
                    if (agent.is_global_status === false) {
                        return true;
                    }
                    return ["Break", "Do Not Disturb", "Lunch", "Meeting"].indexOf(name) >= 0;
                }
                return ["Break", "Do Not Disturb", "Lunch", "Meeting"].indexOf(name) >= 0;
            },
            shouldSuppressOfferForNonProduction() {
                // Do not suppress once UI shows Available — recovery offers must land (VE-8831).
                if (this.currentAgent?.agent_status_name === "Available") {
                    return false;
                }
                // Intentional idle only (Break/Lunch/Meeting/DND / custom). Call Queue Selection
                // and Pause are type 4 but must still show inbound (get-next from queue selection).
                if (this.isIntentionalNonProductionAgentStatus(this.currentAgent)) {
                    return true;
                }
                // Intended Break/Lunch only suppresses during the offer race itself. A stale flag
                // after manual outbound (Start Manual Call → wrap-up) must not auto-decline.
                if (!this.intendedNonProductionStatusName) {
                    return false;
                }
                const name = this.currentAgent?.agent_status_name;
                return name === "Offering Call" || name === "Offering Saved Place Call";
            },
            clearIntendedNonProductionStatus() {
                this.intendedNonProductionStatusName = null;
            },
            // VE-8387: stale continue_and_start / forceStartNextDial must not dial on device ready / Resume.
            clearDialIntent() {
                this.saveAndNextAction = null;
                this.forceStartNextDial = false;
            },
            trackIntendedNonProductionFromAgent(agent) {
                if (!agent) {
                    return;
                }
                const name = agent.agent_status_name;
                if (this.isIntentionalNonProductionAgentStatus(agent)) {
                    this.intendedNonProductionStatusName = name;
                    // Meeting/Break/etc. — drop pending Dial Next / Return Call so Resume cannot auto-dial.
                    this.clearDialIntent();
                    return;
                }
                if (name === "Pause") {
                    this.clearDialIntent();
                }
                // Keep Break/Lunch intent only while the race is still on an offer status.
                if (name === "Offering Call" || name === "Offering Saved Place Call") {
                    return;
                }
                // Any other production status (Available, Resume, manual dial, wrap-up, declined,
                // etc.) means Break was left — clear so offers are not auto-declined (VE-8831).
                if (name === "Available" || name === "Resume" || agent.status_type !== 4) {
                    this.clearIntendedNonProductionStatus();
                }
            },
            // After decline: restore intentional Break/Lunch/etc. when Offering Call stole status; else Pause (VE-8831).
            // intendedOverride: snapshot taken before decline API (declined agent push can clear the flag).
            afterOfferDecline(intendedOverride) {
                const intended = intendedOverride !== undefined ? intendedOverride : this.intendedNonProductionStatusName;
                if (intended) {
                    if (this.currentAgent?.agent_status_name !== intended) {
                        // rulePush=true returns a Promise; CreateAgent failures usually resolve null (not reject).
                        const restore = this.createAgent({ status_name: intended }, true);
                        if (restore && typeof restore.then === "function") {
                            return restore.then((agent) => {
                                if (!(agent?.id > 0)) {
                                    this.showSnackbar("error", "Unable to restore your previous status. Please select it again.");
                                }
                            }).catch(() => {
                                this.showSnackbar("error", "Unable to restore your previous status. Please select it again.");
                            });
                        }
                        this.showSnackbar("error", "Unable to restore your previous status. Please select it again.");
                    }
                    return Promise.resolve();
                }
                if (!this.isAgentInNonProductionStatus()) {
                    this.createAgentForPause();
                }
                return Promise.resolve();
            },
            rejectInboundOfferForNonProduction(ccqId) {
                if (!(ccqId > 0)) {
                    return;
                }
                const intendedRestore = this.intendedNonProductionStatusName;
                DeclineIncomingCall(ccqId, {
                    agent_clicked_decline: false,
                    attempt_key: this.currentAgent?.attempt_key,
                    skip_create_ignore_call: true,
                    skip_create_declined_agent: true,
                }).then(() => {
                    return this.afterOfferDecline(intendedRestore);
                }).catch(() => {
                    this.showSnackbar("error", "Unable to release inbound call offer. Please refresh if your status looks wrong.");
                    return this.afterOfferDecline(intendedRestore);
                });
            },
            rejectCallTransferForNonProduction(callTransferId) {
                if (!(callTransferId > 0)) {
                    return;
                }
                const intendedRestore = this.intendedNonProductionStatusName;
                DeclineCallTransfer(callTransferId, {
                    agent_clicked_decline: false,
                    attempt_key: this.currentAgent?.attempt_key,
                    skip_create_declined_agent: true,
                }).then(() => {
                    return this.afterOfferDecline(intendedRestore);
                }).catch(() => {
                    this.showSnackbar("error", "Unable to release call transfer offer. Please refresh if your status looks wrong.");
                    return this.afterOfferDecline(intendedRestore);
                });
            },
            rejectSavedPlaceOfferForNonProduction(scheduledCommunicationId) {
                if (!(scheduledCommunicationId > 0)) {
                    return;
                }
                const intendedRestore = this.intendedNonProductionStatusName;
                DeclineSavedPlaceCall(scheduledCommunicationId, {
                    agentClickedDecline: false,
                    attempt_key: this.currentAgent?.attempt_key,
                    skip_create_declined_agent: true,
                }).then(() => {
                    return this.afterOfferDecline(intendedRestore);
                }).catch(() => {
                    this.showSnackbar("error", "Unable to release saved place offer. Please refresh if your status looks wrong.");
                    return this.afterOfferDecline(intendedRestore);
                });
            },
            createAgentForAvailable() {
                if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                    return;
                }

                if (this.isAgentStatusExcludedFromAutoAvailable()) {
                    return;
                }

                // Do not force Available while accepting or already on a live call (VE-6502 / VOLSUP-116).
                // Offering Call is not blocked by status name alone: server allows Available when the
                // previous offer has no open live call (stuck-offer recovery). Live offers are still
                // blocked here via isBusyWithLiveOrAcceptingCall (forceCall / dialog / onCall).
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    // VE-9959: remember intent — wrap-up/teardown can clear busy after Finished arrives.
                    this.queueGetNext();
                    return;
                }
                if (this.isAgentStatusBlockingAutoAvailable()) {
                    // VE-9959: disposition creates Finished async; getNext often races while still on Wrap Up.
                    // Without queuing, the chain ends and nothing re-arms until inbound interrupt / manual action.
                    this.queueGetNext();
                    return;
                }

                // Clear Break/Lunch intent before Available so a recovery offer is not auto-declined (VE-8831).
                this.clearIntendedNonProductionStatus();

                const options = {
                    status_name: "Available",
                }

                return this.createAgent(options);
            },
            // VE-10320: hold getNextInFlight (status picker locked) until auto-Available settles.
            finishGetNextChainAfterAvailableMint(shouldMintAvailable) {
                const chainId = this.getNextChainId;
                if (!shouldMintAvailable) {
                    this.finishGetNextChain();
                    return;
                }

                this.getNextAvailableMintPending = true;
                const mint = this.createAgentForAvailable();
                Promise.resolve(mint).finally(() => {
                    this.getNextAvailableMintPending = false;
                    // Timeout / a newer chain may have already cleared or replaced this one.
                    if (chainId !== this.getNextChainId) {
                        return;
                    }
                    // skipFlush if unmounted — destroy left parent latch for this mint to clear.
                    this.finishGetNextChain({ skipFlush: this._isDestroyed === true });
                });
            },
            createAgentForPause() {
                const options = {
                    status_name: "Pause",
                }

                this.createAgent(options);
            },
            createAgentForFinishedCampaignCustomer() {
                if (!(this.currentCampaignCustomer?.campaign_id > 0)) {
                    return;
                }

                const options = {
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                    noticeable_id: this.currentCampaignCustomer.campaign_customer_id,
                    noticeable_type: "campaign_customer",
                    organization_id: this.currentCampaignCustomer.organization_id,
                    status_name: "Finished CampaignCustomer",
                    scheduled_communication_id: (this.pendingSavedPlaceCall?.scheduled_communication_id || 0),
                }

                this.createAgent(options);
            },
            createAgentForStartCampaignCustomer() {
                if (!(this.currentCampaignCustomer?.campaign_customer_active_id > 0)) {
                    return;
                }

                const options = {
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                    noticeable_id: this.currentCampaignCustomer.campaign_customer_id,
                    noticeable_type: "campaign_customer",
                    organization_id: this.currentCampaignCustomer.organization_id,
                    status_name: "Start CampaignCustomer",
                }

                this.createAgent(options);
            },
            createAgentForStartManualCall() {
                if (!(this.currentCampaignCustomer?.campaign_id > 0)) {
                    return;
                }

                const options = {
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                    noticeable_id: this.currentCampaignCustomer.campaign_customer_id,
                    noticeable_type: "campaign_customer",
                    organization_id: this.currentCampaignCustomer.organization_id,
                    status_name: "Start Manual Call",
                }

                this.createAgent(options);
            },
            declineCallTransfer(agentClickedDecline) {

                // Verify we have a pending record
                if (!(this.pendingCallTransfer?.call_transfer?.id > 0)) {
                    return;
                }

                if (!this.acceptCallTransferDialog) {
                    return;
                }

                // Decline leads to Pause — do not flush a deferred getNext into production.
                this.getNextPending = false;

                // Close dialog
                this.closeAcceptCallTransferDialog();

                // Snapshot before decline API: declined agent push can clear the intended flag.
                const intendedRestore = this.intendedNonProductionStatusName;

                // Init
                const options = {
                    agent_clicked_decline: agentClickedDecline === true,
                    attempt_key:  this.currentAgent?.attempt_key,
                }

                // Decline
                DeclineCallTransfer(this.pendingCallTransfer?.call_transfer?.id, options).then(() => {

                    // Reset pending
                    this.pendingCallTransfer = null;

                    this.afterOfferDecline(intendedRestore);
                }).catch(() => {

                    // VE-10476: a failed decline must still release the offer locally.
                    this.pendingCallTransfer = null;

                    this.showSnackbar("error", "Unable to decline the call transfer. Please refresh if your status looks wrong.");
                    this.afterOfferDecline(intendedRestore);
                });
            },
            declineIncomingCall(agentClickedDecline, skipCreateIgnoreCall) {

                // Verify we have a pending record
                if (!(this.pendingIncomingCall?.call_communication_queue?.call_communication_queue_id > 0)) {
                    return;
                }

                // Verify dialog is open - if not, abort
                if (!this.acceptIncomingCallDialog) {
                    return;
                }

                // Decline leads to Pause — do not flush a deferred getNext into production.
                this.getNextPending = false;

                // Close dialog
                this.closeAcceptIncomingCallDialog();

                // Snapshot before decline API: declined agent push can clear the intended flag.
                const intendedRestore = this.intendedNonProductionStatusName;

                // Init
                const options = {
                    agent_clicked_decline: agentClickedDecline === true,
                    attempt_key:  this.currentAgent?.attempt_key,
                    skip_create_ignore_call: skipCreateIgnoreCall === true,
                }

                // Decline
                DeclineIncomingCall(this.pendingIncomingCall?.call_communication_queue?.call_communication_queue_id, options).then(() => {

                    // Reset pending
                    this.pendingIncomingCall = null;
                    this.clearQueuedPendingIncomingCall();

                    this.afterOfferDecline(intendedRestore);
                }).catch(() => {

                    // VE-10473: a failed decline must still release the offer locally.
                    this.pendingIncomingCall = null;
                    this.clearQueuedPendingIncomingCall();

                    this.showSnackbar("error", "Unable to decline the inbound call. Please refresh if your status looks wrong.");
                    this.afterOfferDecline(intendedRestore);
                });
            },
            declineSavedPlaceCall(agentClickedDecline, skipCreateIgnoreCall) {
                // Verify
                if (!(this.pendingSavedPlaceCall?.scheduled_communication_id > 0)) {
                    return;
                }

                // Verify dialog is open - if not, abort
                if (!this.acceptSavedPlaceDialog) {
                    return;
                }

                // Decline leads to Pause — do not flush a deferred getNext into production.
                this.getNextPending = false;

                // Close dialog
                this.closeAcceptSavedPlaceDialog();

                // Snapshot before decline API: declined agent push can clear the intended flag.
                const intendedRestore = this.intendedNonProductionStatusName;

                const options = {
                    agentClickedDecline: agentClickedDecline === true,
                    attempt_key: this.currentAgent?.attempt_key,
                }

                DeclineSavedPlaceCall(this.pendingSavedPlaceCall?.scheduled_communication_id, options).then(() => {

                    // Reset pending
                    this.pendingSavedPlaceCall = null;

                    this.afterOfferDecline(intendedRestore);
                });
            },
            endCall() {
                this.forceEndCall = true; // Set force to true so the child phone device components pick up end call
            },
            beginManualModeOutboundDialWhileAlreadyInManualMode(validatedOutboundNumber) {
                // Validate that we are already in manual mode 
                if (!this.isManualMode) {
                    return;
                }

                
                // Validate campaign is already set 
                if (!this.currentCampaign || !(this.currentCampaign?.campaign_id > 0)) {
                    return;
                }
                
                // Validate that we have no active campaign customer
                if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                    return;
                }

                // Set force validated outbound number if it's not already set or if it's different from the current one
                if ((!this.forceValidatedOutboundNumber || this.forceValidatedOutboundNumber !== validatedOutboundNumber) && validatedOutboundNumber) {
                    this.setForceValidatedOutboundNumber(validatedOutboundNumber);
                } else if (this.forceValidatedOutboundNumber && !validatedOutboundNumber) {
                    this.endForceValidatedOutboundNumber();
                }

                // No need to auto search here, we're already in the search dialog and trigger search from there

                // Resize window
                Vue.nextTick(() => {
                    this.handleWindowResize();
                });
            },
            enterManualMode(campaign, communicationType, enrollAsEligible, forceCustomer, validatedOutboundNumber) {

                // Note - communication type and forceCustomer are not yet used in this function, but are passed in for consistency with enterManualMode in main.vue

                // Verify
                if (!(campaign?.campaign_id > 0)) {
                    this.finishGetNextChain();
                    // VE-10188: stale manual cache — leave manual mode and move to Available.
                    if (this.isManualMode) {
                        this.isManualMode = false;
                        this.manualModeCampaign = null;
                        this.manualModeEnrollAsEligible = false;
                        this.createAgentForAvailable();
                    }
                    return;
                }

                // Set this to keep consistent with entering manual mode from communication queue selection
                // And to pass as prop down to device for force start next dial
                if ((!this.forceValidatedOutboundNumber || this.forceValidatedOutboundNumber !== validatedOutboundNumber) && validatedOutboundNumber) {
                    this.setForceValidatedOutboundNumber(validatedOutboundNumber);
                } else if (this.forceValidatedOutboundNumber && !validatedOutboundNumber) {
                    this.endForceValidatedOutboundNumber();
                }

                // Set manual mode fields
                this.currentCampaign = campaign;
                this.isManualMode = true;
                this.currentCampaignCustomer = null;
                this.saveAndNextAction = null;
                this.resetCurrentCampaignCustomerDefaults(false);

                // Reset
                this.voiceMailRecording = null;
                this.pendingSavedPlaceCall = null;
                this.isSavedPlaceCall = false;
                this.endVoiceMailRecording(false, true);

                // Create a cache of the manual mode campaign in case where user switches between inbound and manual mode
                // Needs to be a separate reference because currentCampaign gets reset to null via inbound
                this.manualModeCampaign = { ...campaign };
                this.manualModeEnrollAsEligible = enrollAsEligible;

                // Run in next tick so screen resets properly
                Vue.nextTick(() => {

                    // Reinit current cc with temp object
                    this.currentCampaignCustomer = {
                        campaign_customer_active_id: null,
                        account_id: this.currentCampaign.account_id,
                        assigned_to: null,
                        campaign_customer_id: null,
                        campaign_id: this.currentCampaign.campaign_id,
                        current_scheduled_communication_id: null,
                        customer_id: null,
                        customer_vehicle_id: null,
                        forte_crm_key_id: null,
                        gm_ro_bac_is_valid: null,
                        inline_crm_key: null,
                        next_attemptable_id: null,
                        next_attemptable_type: null,
                        noticeable_id: null,
                        noticeable_type: null,
                        organization_id: this.currentCampaign.organization_id,
                        organization_time_zone_id: this.currentCampaign.organization_time_zone_id,
                        account_forte_crm_enabled: false,
                        account_inline_crm_enabled: false,
                        campaign_name: this.currentCampaign.campaign_name,
                        campaign_disposition_mode: this.currentCampaign.disposition_mode,
                        enrolled_date: null,
                        expiration_code: null,
                        eventable_id: null,
                        eventable_type: null,
                        next_attemptable_value: null,
                        next_attempt_number: null,
                        organization_name: this.currentCampaign.organization_name,
                        prospect_id: null,
                        purpose: "default",
                        status: null,
                        mykaarma_enabled: false,
                        tekion_enabled: false,
                        total_communication_dispositions: 0,
                        toyoguard_enabled: false,
                        user_email: null,
                        user_first_name: null,
                        user_last_name: null,
                        conversation_group: null,
                        customer: null,
                        incoming_phone_number: { ...this.currentCampaign.incoming_phone_number },
                        vin_enabled: false,
                        xtime_enabled: false,
                    }

                    // Move agent into manual call status
                    this.createAgentForStartManualCall();

                    // Stop loader
                    this.isLoading = false;
                    this.finishGetNextChain();

                     // If we have a validatedOutboundNumber, we want to dial directly out from the manual mode dialog 
                    if (validatedOutboundNumber) {
                        // auto search for customers based on phone number
                        this.initialPhoneNumber = validatedOutboundNumber;
                    } 

                    // Resize window
                    Vue.nextTick(() => {
                        this.handleWindowResize();
                    });
                });
            },
            ensureOtherCampaignCustomersBackToAssigned() {
                if (!this.currentCampaignCustomer || !(this.campaignCustomers && this.campaignCustomers.length > 0)) {
                    return false;
                }

                for (let i = 0; i < this.campaignCustomers.length; i++) {

                    const other = this.campaignCustomers[i];
                    if (other?.campaign_customer_active_id !== this.currentCampaignCustomer.campaign_customer_active_id && other?.status === "in_progress") {
                        other.status = "assigned";
                    }
                }

                return true;
            },
            exitManualMode() {

                // Unassign if someone is in scope
                if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                    this.unassignCampaignCustomerActive(true);
                }

                this.currentCampaign = null;
                this.manualModeCampaign = null;
                this.manualModeEnrollAsEligible = false;
                this.isManualMode = false;
                this.currentCampaignCustomer = null;
                this.resetCurrentCampaignCustomerDefaults(false);

                if (this.forceValidatedOutboundNumber) {
                    this.endForceValidatedOutboundNumber();
                }

                // needed for when we enter manual mode from anywhere that adds a force customer
                if (this.forceCustomer && this.validEndForceCustomer) {
                    this.endForceCustomer(true);
                }

                // Reinit screen
                this.finishGetNextChain();
                this.getNext(null);
            },
            findOrSetInProgressCampaignCustomer(chainId) {
                if (!(!!this.campaignCustomers && this.campaignCustomers.length > 0)) {
                    if (chainId === this.getNextChainId) {
                        this.finishGetNextChain();
                    }
                    return;
                }

                // Loop through campaign customers
                for (let i = 0; i < this.campaignCustomers.length; i++) {

                    // Init campaign customer
                    const campaignCustomer = this.campaignCustomers[i];

                    // If the status is present, set as current
                    if (!this.currentCampaignCustomer && campaignCustomer?.account_id > 0 && campaignCustomer?.campaign_customer_active_id > 0 && campaignCustomer?.status === 'in_progress') {

                        // Set
                        this.currentCampaignCustomer = campaignCustomer;
                        this.applyMykaarmaScreenPopEnabled(campaignCustomer.organization_id, campaignCustomer.mykaarma_enabled);

                        break;
                    }
                }

                // If zero in progress records in array, take the first record and mark it as in progress
                if (!this.currentCampaignCustomer) {

                    // Set campaign customer on data
                    this.currentCampaignCustomer = this.campaignCustomers[0];
                    this.applyMykaarmaScreenPopEnabled(
                        this.currentCampaignCustomer?.organization_id,
                        this.currentCampaignCustomer?.mykaarma_enabled,
                    );

                    // Update campaign customer to 'in progress'
                    this.updateCampaignCustomerActive({ account_id: this.currentCampaignCustomer?.account_id, campaign_customer_active_id: this.currentCampaignCustomer?.campaign_customer_active_id, status: "in_progress" }, false);
                } else {

                    // Set isLoading back to false since we already have our current campaign customer
                    this.isLoading = false;
                    if (chainId === this.getNextChainId) {
                        this.finishGetNextChain();
                    }

                    // switch customer needs to have a valid current campaign in scope
                    this.setCurrentCampaignFromCurrentCampaignCustomerActive();

                    // move agent into start status
                    this.createAgentForStartCampaignCustomer();
                }

                return;
            },
            getAutoAssistantRequest() {

                // If we already have valid data for the current call, return
                if ((this.validAutoAssistData && this.autoAssistData.call_id === this.callId) || !this.validCallId) {
                    return;
                }

                const options = {
                    call_id: this.callId,
                }

                GetAutoAssistantRequests(options).then((response) => {
                    if (response?.Error === null && response.Data?.AutoAssistantRequests?.length > 0) {
                        this.autoAssistData = response.Data.AutoAssistantRequests[0];
                    } else {
                        if (!this.firstRequestSent) {
                            // If this is our first request, retry again after waiting 20 seconds for Rac
                            this.queueFinalAutoAssistantRequest();
                        } else {
                            // Otherwise, we've tried twice, and still haven't gotten anything, so display error (handled in auto assist component)
                            this.autoAssistData = { auto_assistant_type: "error" }
                        }
                    }

                    this.firstRequestSent = true;
                })
            },
            getNext(lastFunc) {
                if (lastFunc === null) {
                    if (this.getNextInFlight) {
                        this.queueGetNext();
                        return;
                    }
                    if (this.isBusyWithLiveOrAcceptingCall()) {
                        this.queueGetNext();
                        return;
                    }
                    if (this.vinLoginDecisionPending) {
                        this.queueGetNext();
                        this.onVinLoginDecisionRequired();
                        return;
                    }

                    // Fulfilling a deferred request (or a fresh one).
                    this.getNextPending = false;
                    this.getNextChainId += 1;
                    this.getNextInFlight = true;
                    if (typeof this.setGetNextInFlight === 'function') {
                        this.setGetNextInFlight(true);
                    }
                    this.isHandlingInboundCall = false;
                    this.clearStuckAcceptedCallTimeout();

                    // VE-10473 / VE-10476: no live call and no open offer — any leftover is stale and blocks get-next.
                    this.pendingIncomingCall = null;
                    this.pendingCallTransfer = null;
                } else if (!this.getNextInFlight) {
                    // Mid-chain continuation after inflight was cleared — re-queue a fresh chain.
                    this.queueGetNext();
                    Vue.nextTick(() => {
                        this.flushGetNextPending();
                    });
                    return;
                }

                const chainId = this.getNextChainId;
                this.armGetNextInFlightTimeout(chainId);

                // STEP 1: Internal transfer check first
                if (lastFunc === null) {
                    return this.assignNextInboundCallTransfer(chainId);
                }

                if (chainId !== this.getNextChainId) {
                    return;
                }

                // STEP 2: Save place in line call check
                if (lastFunc === "assignNextInboundCallTransfer" && (!this.isManualMode || (this.isManualMode && this.manualModeInbound))) {
                    return this.assignNextSavedPlaceInLine(chainId);
                }

                if (chainId !== this.getNextChainId) {
                    return;
                }

                // STEP 3: Inbound call check next (Carlie live handoffs first)
                // NOTE - When in manual mode, only search for next inbound call if setting enabled
                if (lastFunc === "assignNextSavedPlaceInLine" && (!this.isManualMode || (this.isManualMode && this.manualModeInbound))) {
                    return this.assignNextInboundCall(chainId);
                }

                if (chainId !== this.getNextChainId) {
                    return;
                }

                // STEP 4: Missed calls check
                if (lastFunc === "assignNextInboundCall" && (!this.isManualMode || (this.isManualMode && this.manualModeInbound))) {
                    return this.assignNextMissedCall(chainId);
                }

                if (chainId !== this.getNextChainId) {
                    return;
                }

                // STEP 5: Finally, assign an outbound customer or enter back into manual mode
                return this.isManualMode ? this.enterManualMode(this.manualModeCampaign, null, this.manualModeEnrollAsEligible, null, null) : this.assignReadyCampaignCustomers(chainId);
            },
            handleAfterCampaignCustomerActive(ccActiveID) {

                // If present, handle
                if (ccActiveID > 0) {

                    // This will not be present when doing a force campaign customer via the manager live dashboard
                    if (this.campaignCustomers?.length > 0) {

                        // Find idx
                        const idx = this.campaignCustomers.findIndex(i => i.campaign_customer_active_id === ccActiveID);
                        if (idx >= 0) {

                            // Remove from slice
                            this.campaignCustomers.splice(idx, 1);
                        }
                    }

                    // Determine if we need to reinit
                    if (this.currentCampaignCustomer?.campaign_customer_active_id > 0 && this.currentCampaignCustomer?.campaign_customer_active_id === ccActiveID) {
                        this.currentCampaignCustomer = null;
                    }
                }

                this.finishGetNextChain();
                return this.getNext(null);
            },
            handleAssignNextInboundCallResult(data) {
                const pending = data?.pending_incoming_call;
                const ccq = data?.call_communication_queue;
                if (!(pending?.call_communication_queue?.call_communication_queue_id > 0)) {
                    // Assign succeeded but push payload build failed — reclaim after RAC/status settles.
                    if (ccq?.id > 0 && ccq?.status === "pending") {
                        this.scheduleRecoverOfferingCallAcceptUI();
                    }
                    this.finishGetNextChain();
                    return;
                }

                // VE-10188: mirror onPushInboundCallToUser — queue when busy, open when idle.
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    this.queuePendingIncomingCall(pending);
                    this.finishGetNextChain();
                    return;
                }

                if (this.openPendingIncomingCall(pending)) {
                    return;
                }

                this.finishGetNextChain();
            },
            handleAssignNextCallTransferResult(data) {
                const pending = data?.pending_internal_call_transfer;
                const callTransfer = data?.call_transfer;
                if (!(pending?.call_transfer?.id > 0)) {
                    if (callTransfer?.id > 0 && callTransfer?.transfer_status === "pending") {
                        this.scheduleRecoverOfferingCallAcceptUI();
                    }
                    this.finishGetNextChain();
                    return;
                }

                if ((this.acceptCallTransferDialog || this.isProcessingAcceptCallTransfer) &&
                    this.pendingCallTransfer?.call_transfer?.id === pending.call_transfer.id) {
                    this.clearQueuedPendingCallTransfer();
                    this.finishGetNextChain();
                    return;
                }

                if (this.isBusyWithLiveOrAcceptingCall()) {
                    this.queuePendingCallTransfer(pending);
                    this.finishGetNextChain();
                    return;
                }

                if (this.openPendingCallTransfer(pending)) {
                    return;
                }

                this.finishGetNextChain();
            },
            handleAssignNextSavedPlaceResult(data) {
                const pending = data?.pending_saved_place_call;
                if (!(pending?.scheduled_communication_id > 0)) {
                    this.finishGetNextChain();
                    return;
                }

                if ((this.acceptSavedPlaceDialog || this.isProcessingAcceptSavedPlaceCall) &&
                    this.pendingSavedPlaceCall?.scheduled_communication_id === pending.scheduled_communication_id) {
                    this.clearQueuedPendingSavedPlaceCall();
                    this.finishGetNextChain();
                    return;
                }

                if (this.isBusyWithLiveOrAcceptingCall()) {
                    this.queuePendingSavedPlaceCall(pending);
                    this.finishGetNextChain();
                    return;
                }

                if (this.openPendingSavedPlaceCall(pending)) {
                    return;
                }

                this.finishGetNextChain();
            },
            handleSkippedCampaignCustomer(removedFromQueue) {

                // Show snackbar
                this.showSnackbar("green", "Successfully skipped customer");

                // Create agent
                this.createAgentForFinishedCampaignCustomer();

                // If we removed from the queue, we just need to handle the after. Otherwise we need to actually unassign
                return removedFromQueue === true ? this.handleAfterCampaignCustomerActive(this.currentCampaignCustomer?.campaign_customer_active_id) : this.unassignCampaignCustomerActive(true);
            },
            handleUpdateCurrentCampaignCustomer(options) {

                // Verify same customer
                if (!(options?.customer_id > 0 && options.customer_id === this.currentCampaignCustomer?.customer?.customer_id)) {
                    return;
                }

                // Set customer params
                this.currentCampaignCustomer.customer = UpdateAssignedCustomerFromCustomerCommunicationManager(options, this.currentCampaignCustomer.customer);

                return;
            },
            handleWindowClosed() {

                // If user has pending incoming call, need to decline it so the call gets put back into queue or goes to another available agent
                if (this.acceptIncomingCallDialog === true && this.pendingIncomingCall?.call_communication_queue?.call_communication_queue_id > 0) {
                    this.declineIncomingCall(false);
                }

                // If user has pending call transfer, need to decline it
                if (this.acceptCallTransferDialog === true && this.validPendingCallTransfer) {
                    this.declineCallTransfer(false);
                }

                // Same rule as inbound: only an offer the agent actually saw.
                if (this.acceptSavedPlaceDialog === true && this.pendingSavedPlaceCall?.scheduled_communication_id > 0) {
                    this.declineSavedPlaceCall(false);
                }
            },
            handleWindowResize() {

                // Declare constants
                const controlBarPx = 56;
                const incomingDetailsPx = 64;
                const paddingPx = 32;
                const topHeader = 64;

                // Calcuate
                this.contentRowHeight = this.$refs.phoneContentRow?.clientHeight - topHeader;
                this.customerProfileHeight = this.contentRowHeight - paddingPx;

                // Set survey height
                this.surveyHeight = this.customerProfileHeight - controlBarPx - incomingDetailsPx;
            },
            initMainErrorAlert() {
                this.mainErrorAlert = {
                    show: false,
                    text: null,
                }
            },
            initPendingSavedPlaceCall() {
                // Verify not a supervisor trying to barge/listen/coach
                if (this.isSupervisor) {
                    this.pendingSavedPlaceCall = null;
                    return;
                }

                // Verify legit call communication queue
                const ccq = this.pendingSavedPlaceCall.call_communication_queue;
                if (!(ccq?.call_communication_queue_id > 0) || !(ccq?.account_id > 0) || !(ccq?.status?.length > 0)) {
                    this.pendingSavedPlaceCall = null;
                    return;
                }

                // Verify ccq's status is pending
                if (ccq.status !== "ivr_callback_pending") {
                    this.pendingSavedPlaceCall = null;
                    return;
                }

                // Verify account matches is current user's account
                if (this.currentUser?.activated_account_id !== ccq.account_id) {
                    this.pendingSavedPlaceCall = null;
                    return;
                }

                // Ensure saved place dialog is not already open
                if (this.acceptSavedPlaceDialog || this.isProcessingAcceptSavedPlaceCall) {
                    return;
                }

                // Verify legit cc
                const assignedCampaignCustomer = this.pendingSavedPlaceCall?.assigned_campaign_customer;
                if (!(assignedCampaignCustomer?.campaign_id > 0) || !(assignedCampaignCustomer?.account_id > 0)) {
                    this.pendingSavedPlaceCall = null;
                    return;
                }

                // Verify legit call
                const call = this.pendingSavedPlaceCall?.call;
                if (!(call?.id > 0) || call.id !== ccq.call_id) {
                    this.pendingSavedPlaceCall = null;
                    return;
                }

                // Reset defaults
                this.resetCurrentCampaignCustomerDefaults(false);

                // Opens accept dialog
                this.acceptSavedPlaceDialog = true;
                this.finishGetNextChain();

            },
            initiateSupervisorCall() {
                if (!(this.parentForceCall?.assigned_campaign_customer?.campaign_id > 0)) {
                    return;
                }

                // Set current back to null
                this.currentCampaign = null;
                this.currentCampaignCustomer = null;
                this.voiceMailRecording = null;
                this.pendingSavedPlaceCall = null;
                this.isSavedPlaceCall = false;
                this.resetCurrentCampaignCustomerDefaults(false);

                // Run in next tick so screen resets properly
                Vue.nextTick(() => {

                    if (this.forceCampaignCustomer?.campaign_customer_active_id > 0) {
                        // Set as current
                        this.currentCampaignCustomer = { ...this.forceCampaignCustomer };
                        this.currentCampaignCustomer.incoming_phone_number = this.parentForceCall.assigned_campaign_customer.incoming_phone_number;
                    } else {
                        // set current campaign customer active
                        this.currentCampaignCustomer = { ...this.parentForceCall.assigned_campaign_customer };
                    }

                    // Set current campaign
                    this.currentCampaign = {
                        account_id: this.parentForceCall.assigned_campaign_customer.account_id,
                        campaign_id: this.parentForceCall.assigned_campaign_customer.campaign_id,
                        organization_id: this.parentForceCall.assigned_campaign_customer.organization_id,
                        organization_time_zone_id: null,
                        campaign_name: this.parentForceCall.assigned_campaign_customer.campaign_name,
                        organization_name: this.parentForceCall.assigned_campaign_customer.organization_name,
                    }

                    // Add to slice
                    // todo - determine if we should do this for manual calls too
                    this.campaignCustomers.unshift(this.currentCampaignCustomer);

                    // Set call
                    this.forceCall = { ...this.parentForceCall.call };
                    this.forceConference = { ...this.parentForceCall.conference };

                    // Set web rtc if present
                    if (this.parentForceWebRtcParticipant?.id > 0 && this.parentForceWebRtcSession?.id > 0) {
                        // Set web rtc
                        this.forceWebRtcSession = { ...this.parentForceWebRtcSession };
                        this.forceWebRtcParticipant = { ...this.parentForceWebRtcParticipant };
                    }

                    // If current cc already has a cc_active_ID, then move into "in progress" status
                    if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                        this.moveCampaignCustomerActiveToInProgress();
                    } else {
                        // auto search for customers based on phone number
                        this.initialPhoneNumber = this.forceCall?.from_number;
                    }

                    // Resize window
                    Vue.nextTick(() => {
                        this.handleWindowResize();
                    });
                });
            },
            moveCampaignCustomerActiveToInProgress(forceForInbound) {

                // Verify legit cc active and that we aren't already in progress status
                if (!(this.currentCampaignCustomer?.campaign_customer_active_id > 0) || this.currentCampaignCustomer.status === "in_progress") {
                    return;
                }

                // Init options
                const options = {
                    campaign_customer_active_id: this.currentCampaignCustomer.campaign_customer_active_id,
                    campaign_customer_id: this.currentCampaignCustomer.campaign_customer_id,
                    account_id: this.currentCampaignCustomer.account_id,
                    force_for_inbound: forceForInbound,
                    status: "in_progress",
                }

                // Update record in db
                this.updateCampaignCustomerActive(options, true);
            },
            applyMykaarmaScreenPopEnabled(organizationId, serverEnabled) {
                if (!this.currentCampaignCustomer) {
                    return;
                }
                this.$set(
                    this.currentCampaignCustomer,
                    'mykaarma_enabled',
                    this.resolveMykaarmaScreenPopEnabled(organizationId, serverEnabled),
                );
            },
            newEnrollmentSuccess(ccActive, skipStatusMove) {

                // Verify
                if (!(ccActive?.campaign_customer_active_id > 0)) {
                    return;
                }

                // An accepted inbound owns the customer context. Ignore a stale manual-mode enrollment
                // (e.g. an in-flight enroll that resolves after accept) for the suspended manual campaign.
                // Deliberate switches pass skipStatusMove=true and are unaffected.
                if (!skipStatusMove
                    && this.isHandlingInboundCall // are we actively handling an inbound (or other type of pushed call - saved place, transfer etc)
                    && this.manualModeCampaign?.campaign_id > 0 // is there a suspended manual mode campaign (did the agent accept the inbound from manual mode)
                    && ccActive.campaign_id === this.manualModeCampaign.campaign_id // enrollment belongs to the suspended manual campaign (in-flight manual enroll, or forced manual customer) — not the live call.
                    && ccActive.campaign_id !== this.currentCampaign?.campaign_id) { // the enrollment campaign doesn't match the active inbound call's  campaign
                    return;
                }

                // If null, reset back to empty array
                if (!this.campaignCustomers) {
                    this.campaignCustomers = [];
                }

                // If null, set to empty object
                if (!this.currentCampaignCustomer) {
                    this.currentCampaignCustomer = {};
                }

                // // Set fields on cc active pointer
                this.currentCampaignCustomer.campaign_customer_active_id = ccActive.campaign_customer_active_id;
                this.currentCampaignCustomer.account_id = ccActive.account_id;
                this.currentCampaignCustomer.assigned_to = ccActive.assigned_to;
                this.currentCampaignCustomer.campaign_customer_id = ccActive.campaign_customer_id;
                this.currentCampaignCustomer.campaign_id = ccActive.campaign_id;
                this.currentCampaignCustomer.current_scheduled_communication_id = ccActive.current_scheduled_communication_id;
                this.currentCampaignCustomer.customer_id = ccActive.customer_id;
                this.currentCampaignCustomer.customer_vehicle_id = ccActive.customer_vehicle_id;
                this.currentCampaignCustomer.eventable_id = ccActive.eventable_id;
                this.currentCampaignCustomer.eventable_type = ccActive.eventable_type;
                this.currentCampaignCustomer.forte_crm_key_id = ccActive.forte_crm_key_id;
                this.currentCampaignCustomer.gm_ro_bac_is_valid = ccActive.gm_ro_bac_is_valid;
                this.currentCampaignCustomer.has_telematic_alert_type_mapping = ccActive.has_telematic_alert_type_mapping;
                this.currentCampaignCustomer.inline_crm_key = ccActive.inline_crm_key;
                this.currentCampaignCustomer.next_attemptable_id = ccActive.next_attemptable_id;
                this.currentCampaignCustomer.next_attemptable_type = ccActive.next_attemptable_type;
                this.currentCampaignCustomer.noticeable_id = ccActive.noticeable_id;
                this.currentCampaignCustomer.noticeable_type = ccActive.noticeable_type;
                this.currentCampaignCustomer.organization_id = ccActive.organization_id;
                this.currentCampaignCustomer.organization_time_zone_id = ccActive.organization_time_zone_id;
                this.currentCampaignCustomer.account_forte_crm_enabled = ccActive.account_forte_crm_enabled;
                this.currentCampaignCustomer.account_inline_crm_enabled = ccActive.account_inline_crm_enabled;
                this.currentCampaignCustomer.campaign_name = ccActive.campaign_name;
                this.currentCampaignCustomer.campaign_disposition_mode = ccActive.campaign_disposition_mode;
                this.currentCampaignCustomer.enrolled_date = ccActive.enrolled_date;
                this.currentCampaignCustomer.expiration_code = ccActive.expiration_code;
                this.currentCampaignCustomer.next_attemptable_value = ccActive.next_attemptable_value;
                this.currentCampaignCustomer.next_attempt_number = ccActive.next_attempt_number;
                this.currentCampaignCustomer.noticeable_id = ccActive.noticeable_id;
                this.currentCampaignCustomer.noticeable_type = ccActive.noticeable_type;
                this.currentCampaignCustomer.organization_name = ccActive.organization_name;
                this.currentCampaignCustomer.prospect_id = ccActive.prospect_id;
                this.currentCampaignCustomer.purpose = ccActive.purpose;
                this.currentCampaignCustomer.status = ccActive.status;
                this.currentCampaignCustomer.total_communication_dispositions = ccActive.total_communication_dispositions;
                this.applyMykaarmaScreenPopEnabled(ccActive.organization_id, ccActive.mykaarma_enabled);
                this.currentCampaignCustomer.tekion_enabled = ccActive.tekion_enabled;
                this.currentCampaignCustomer.tekion_customer_sid = ccActive.tekion_customer_sid;
                this.currentCampaignCustomer.toyoguard_enabled = ccActive.toyoguard_enabled;
                this.currentCampaignCustomer.xtime_enabled = ccActive.xtime_enabled;
                this.currentCampaignCustomer.user_email = ccActive.user_email;
                this.currentCampaignCustomer.user_first_name = ccActive.user_first_name;
                this.currentCampaignCustomer.user_last_name = ccActive.user_last_name;
                this.currentCampaignCustomer.vin_enabled = ccActive.vin_enabled;
                this.currentCampaignCustomer.conversation_group = ccActive.conversation_group;
                this.currentCampaignCustomer.customer = ccActive.customer;
                this.currentCampaignCustomer.is_integrations_api_calendar_ui_enabled = ccActive.is_integrations_api_calendar_ui_enabled;

                // Run only if we need to
                if (!skipStatusMove) {

                    // Move cc active into in progress
                    this.moveCampaignCustomerActiveToInProgress();
                }
                // Resize window
                Vue.nextTick(() => {
                    this.handleWindowResize();
                });
            },
            onAutoAssistantEventNew(response){

                // Ignore if we already have valid data for the current call
                if (this.validAutoAssistData && this.autoAssistData.call_id === this.callId) {
                    return;
                }

                this.autoAssistData = response.Data;
            },
            onNewCommunicationDisposition(response) {

                // Verify legit communication disposition
                const data = response?.Data;
                const communicationDisposition = data?.communication_disposition;
                if (!(communicationDisposition?.communication_disposition_id > 0) || !(communicationDisposition?.campaign_customer_active_id > 0) || !(communicationDisposition?.account_id > 0)) {
                    return;
                }

                // Verify array has records
                if (!(this.campaignCustomers?.length > 0)) {
                    return;
                }

                // Loop through
                for (let i = 0; i < this.campaignCustomers.length; i++) {

                    // Init
                    const ccActive = this.campaignCustomers[i];

                    // Verify the campaign customer is the same and if so, set total
                    if (ccActive?.campaign_customer_active_id === communicationDisposition.campaign_customer_active_id) {
                        applyIncomingTotalCommunicationDispositions(ccActive, data?.total_communication_dispositions);
                        break;
                    }
                }
            },
            onAssignedCampaignCustomerRefresh() {
                // While accepting or owning a live/inbound context, do not re-run get next.
                if (this.isBusyWithLiveOrAcceptingCall() || this.getNextInFlight) {
                    return null;
                }
                // Offering with no accept UI — debounced reclaim (avoid racing websocket push).
                if (this.currentAgent?.agent_status_name === "Offering Call" && !this.acceptIncomingCallDialog && !this.validPendingIncomingCall && !this.acceptCallTransferDialog && !this.validPendingCallTransfer) {
                    this.scheduleRecoverOfferingCallAcceptUI();
                    return null;
                }
                if (this.currentAgent?.agent_status_name === "Offering Saved Place Call" && !this.acceptSavedPlaceDialog && !this.validPendingSavedPlaceCall) {
                    this.scheduleRecoverOfferingSavedPlaceCallAcceptUI();
                    return null;
                }
                return this.renderNoCurrentCustomer === true || this.isCurrentAgentStatusPossibleSuspicious() ? this.getNext(null) : null; // If the agent does not currently have a current customer, get next
            },
            isCurrentAgentStatusPossibleSuspicious() {
                return [
                    "Finished CampaignCustomer",
                    "Offering Call",
                    "Offering Saved Place Call",
                    "Phone - Accepted Incoming Call",
                    "Phone - Accepted Incoming Call Transfer",
                    "Phone - Accepted Saved Place Call",
                    "SMS Message - Processed Customer",
                ].indexOf(this.currentAgent?.agent_status_name) >= 0;
            },
            onVinLoginDecisionRequired() {
                this.showSnackbar("warning", "Please log into VinSolutions or choose Ignore and Continue before starting more calls.");
                this.openVinLoginDecisionDialog();
                this.pauseForVinLoginDecisionIfSafe();
                return true;
            },
            onCallCommunicationQueueUpdate(response) {

                // Verify legit call communication queue
                const ccq = response?.Data;
                if (!(ccq?.call_communication_queue_id > 0) || !(ccq?.account_id > 0) || !(ccq?.status?.length > 0)) {
                    return;
                }

                // Verify account matches is current user's account
                if (this.currentUser?.activated_account_id !== ccq.account_id) {
                    return;
                }

                // The purpose here is to remove the pending inbound call modal if the user isn't fast enough and the call gets completed (dropped)
                // So we need to verify that the pendingIncomingCall matches this ccq
                // If the status of the new ccq instance isn't pending anymore and we still have the dialog open, then close the dialog, create an ignore call record, and move agent to pause
                if (ccq.status !== "pending") {
                    if (ccq.call_communication_queue_id === this.pendingIncomingCall?.call_communication_queue?.call_communication_queue_id && this.acceptIncomingCallDialog === true) {
                        this.declineIncomingCall(false, true);
                    }
                    if (ccq.call_communication_queue_id === this.queuedPendingIncomingCallCcqId) {
                        const staleCcqId = this.queuedPendingIncomingCallCcqId;
                        this.clearQueuedPendingIncomingCall();
                        if (this.currentAgent?.agent_status_name === "Offering Call" && staleCcqId > 0) {
                            this.releaseQueuedInboundOffer(staleCcqId);
                        }
                    }
                }
                if (ccq.status !== "ivr_callback_pending" && ccq.call_communication_queue_id === this.queuedPendingSavedPlaceCall?.call_communication_queue?.call_communication_queue_id) {
                    const staleScId = this.queuedPendingSavedPlaceCallId;
                    this.clearQueuedPendingSavedPlaceCall();
                    if (this.currentAgent?.agent_status_name === "Offering Saved Place Call" && staleScId > 0) {
                        this.releaseQueuedSavedPlaceOffer(staleScId);
                    }
                }
            },
            // Sent when Carlie's analysis finishes while the agent is still on the call she transferred.
            onCarlieAnalysisUpdate(response) {
                const data = response?.Data;
                if (!(data?.ai_communication_id > 0)) {
                    return;
                }
                if (data.ai_communication_id !== this.carlieLiveHandoff?.aiCommunicationId) {
                    this.earlyCarlieAnalysisUpdate = data;
                    return;
                }
                this.carlieLiveHandoff = { ...this.carlieLiveHandoff, analysis: data.analysis || null };
            },
            onCallTransferUpdate(response) {

                // Verify legit call transfer
                const callTransfer = response?.Data;
                if (!(callTransfer?.id > 0) || !(callTransfer?.account_id > 0) || !(callTransfer?.transfer_status?.length > 0)) {
                    return;
                }

                // Verify account matches is current user's account
                if (this.currentUser?.activated_account_id !== callTransfer.account_id) {
                    return;
                }

                // The purpose here is to remove the pending call transfer modal if the user isn't fast enough and the call gets completed (dropped)
                // So we need to verify that the pendingCallTransfer matches this call transfer
                // If the status of the new call transfer instance isn't pending anymore and we still have the dialog open, then we need to decline the transfer
                if (callTransfer.id === this.pendingCallTransfer?.call_transfer?.id && callTransfer.transfer_status !== "pending" && this.acceptCallTransferDialog === true) {
                    this.declineCallTransfer(false);
                }
                if (callTransfer.id === this.queuedPendingCallTransferId && callTransfer.transfer_status !== "pending") {
                    const staleId = this.queuedPendingCallTransferId;
                    this.clearQueuedPendingCallTransfer();
                    if (this.currentAgent?.agent_status_name === "Offering Call" && staleId > 0) {
                        this.releaseQueuedCallTransferOffer(staleId);
                    }
                }
            },
            onNewAssignedCampaignCustomer(response) {
                if (!this.isSupervisor) {
                    return;
                }
                
                //Check if noticeable type is calla nd noticeable id is the same as the call id
                if (!response?.Data?.noticeable_type || !response?.Data?.noticeable_id || response?.Data?.noticeable_type !== "call" || response?.Data?.noticeable_id !== this.forceCall?.parent_id) {
                    return;
                }

                const campaignCustomer = response?.Data

                this.newEnrollmentSuccess(campaignCustomer, true)

            },
            isValidPendingIncomingCallData(data) {
                const ccq = data?.call_communication_queue;
                if (!(ccq?.call_communication_queue_id > 0) || !(ccq?.account_id > 0) || !(ccq?.user_id > 0) || !(ccq?.status?.length > 0)) {
                    return null;
                }

                if (ccq.status !== "pending") {
                    return null;
                }

                if (this.currentUser?.activated_account_id !== ccq.account_id || this.currentUser?.user_id !== ccq.user_id) {
                    return null;
                }

                const assignedCampaignCustomer = data?.assigned_campaign_customer;
                if (!(assignedCampaignCustomer?.campaign_id > 0) || !(assignedCampaignCustomer?.account_id > 0)) {
                    return null;
                }

                const call = data?.call;
                if (!(call?.id > 0) || call.id !== ccq.call_id) {
                    return null;
                }

                return ccq;
            },
            openPendingIncomingCall(data) {

                const ccq = this.isValidPendingIncomingCallData(data);
                if (!ccq) {
                    return false;
                }

                if (this.acceptIncomingCallDialog || this.isProcessingAcceptIncomingCall) {
                    return false;
                }

                if (this.shouldSuppressOfferForNonProduction()) {
                    this.rejectInboundOfferForNonProduction(ccq.call_communication_queue_id);
                    this.finishGetNextChain();
                    return false;
                }

                this.resetCurrentCampaignCustomerDefaults(false);
                this.clearRecoverOfferingCallAcceptUISchedule();
                this.pendingIncomingCall = data;
                this.acceptIncomingCallDialog = true;
                this.finishGetNextChain();
                return true;
            },
            queuePendingIncomingCall(data) {
                const ccq = this.isValidPendingIncomingCallData(data);
                if (!ccq) {
                    return false;
                }

                if (this.shouldSuppressOfferForNonProduction()) {
                    this.rejectInboundOfferForNonProduction(ccq.call_communication_queue_id);
                    return false;
                }

                const ccqId = ccq.call_communication_queue_id;
                if (this.queuedPendingIncomingCallCcqId > 0 && this.queuedPendingIncomingCallCcqId !== ccqId) {
                    this.clearQueuedPendingIncomingCall({ decline: true });
                }

                this.queuedPendingIncomingCall = data;
                this.queuedPendingIncomingCallCcqId = ccqId;
                this.queuedPendingIncomingCallQueuedAt = Date.now();
                this.clearRecoverOfferingCallAcceptUISchedule();
                this.armQueuedPendingIncomingCallTtl();
                return true;
            },
            isValidPendingCallTransferData(data) {
                const callTransfer = data?.call_transfer;
                if (!(callTransfer?.id > 0) || !(callTransfer?.account_id > 0) || !(callTransfer?.transfer_status?.length > 0)) {
                    return null;
                }
                if (callTransfer.transfer_status !== "pending") {
                    return null;
                }
                if (this.currentUser?.activated_account_id !== callTransfer.account_id) {
                    return null;
                }
                const assignedCampaignCustomer = data?.assigned_campaign_customer;
                if (!(assignedCampaignCustomer?.campaign_id > 0) || !(assignedCampaignCustomer?.account_id > 0)) {
                    return null;
                }
                const currentCall = data?.current_call;
                if (!(currentCall?.id > 0) || currentCall.id !== callTransfer.current_call_id) {
                    return null;
                }
                const customerCall = data?.customer_call;
                if (!(customerCall?.id > 0) || currentCall.conference_id !== customerCall.conference_id) {
                    return null;
                }
                return callTransfer;
            },
            openPendingCallTransfer(data) {
                const callTransfer = this.isValidPendingCallTransferData(data);
                if (!callTransfer) {
                    return false;
                }
                if (this.acceptCallTransferDialog || this.isProcessingAcceptCallTransfer) {
                    return false;
                }
                if (this.shouldSuppressOfferForNonProduction()) {
                    this.rejectCallTransferForNonProduction(callTransfer.id);
                    this.finishGetNextChain();
                    return false;
                }

                this.resetCurrentCampaignCustomerDefaults(false);
                this.clearRecoverOfferingCallAcceptUISchedule();
                this.pendingCallTransfer = data;
                this.acceptCallTransferDialog = true;
                if (this.queuedPendingCallTransferId === callTransfer.id) {
                    this.clearQueuedPendingCallTransfer();
                }
                this.finishGetNextChain();
                return true;
            },
            queuePendingCallTransfer(data) {
                const callTransfer = this.isValidPendingCallTransferData(data);
                if (!callTransfer) {
                    return false;
                }
                if (this.shouldSuppressOfferForNonProduction()) {
                    this.rejectCallTransferForNonProduction(callTransfer.id);
                    return false;
                }

                const transferId = callTransfer.id;
                if ((this.acceptCallTransferDialog || this.isProcessingAcceptCallTransfer) &&
                    this.pendingCallTransfer?.call_transfer?.id === transferId) {
                    this.clearQueuedPendingCallTransfer();
                    return false;
                }
                if (this.queuedPendingCallTransferId > 0 && this.queuedPendingCallTransferId !== transferId) {
                    this.clearQueuedPendingCallTransfer({ decline: true });
                }

                this.queuedPendingCallTransfer = data;
                this.queuedPendingCallTransferId = transferId;
                this.queuedPendingCallTransferQueuedAt = Date.now();
                this.clearRecoverOfferingCallAcceptUISchedule();
                this.armQueuedPendingCallTransferTtl();
                return true;
            },
            isValidPendingSavedPlaceCallData(data) {
                if (!(data?.scheduled_communication_id > 0)) {
                    return null;
                }
                const ccq = data?.call_communication_queue;
                if (!(ccq?.call_communication_queue_id > 0) || !(ccq?.account_id > 0) || !(ccq?.status?.length > 0)) {
                    return null;
                }
                if (ccq.status !== "ivr_callback_pending") {
                    return null;
                }
                if (this.currentUser?.activated_account_id !== ccq.account_id) {
                    return null;
                }
                const assignedCampaignCustomer = data?.assigned_campaign_customer;
                if (!(assignedCampaignCustomer?.campaign_id > 0) || !(assignedCampaignCustomer?.account_id > 0)) {
                    return null;
                }
                const call = data?.call;
                if (!(call?.id > 0) || call.id !== ccq.call_id) {
                    return null;
                }
                return data;
            },
            openPendingSavedPlaceCall(data) {
                const pending = this.isValidPendingSavedPlaceCallData(data);
                if (!pending) {
                    return false;
                }
                if (this.acceptSavedPlaceDialog || this.isProcessingAcceptSavedPlaceCall) {
                    return false;
                }
                if (this.shouldSuppressOfferForNonProduction()) {
                    this.rejectSavedPlaceOfferForNonProduction(pending.scheduled_communication_id);
                    this.finishGetNextChain();
                    return false;
                }

                this.clearRecoverOfferingSavedPlaceCallAcceptUISchedule();
                this.pendingSavedPlaceCall = pending;
                this.initPendingSavedPlaceCall();
                if (this.acceptSavedPlaceDialog === true && this.queuedPendingSavedPlaceCallId === pending.scheduled_communication_id) {
                    this.clearQueuedPendingSavedPlaceCall();
                }
                return this.acceptSavedPlaceDialog === true;
            },
            queuePendingSavedPlaceCall(data) {
                const pending = this.isValidPendingSavedPlaceCallData(data);
                if (!pending) {
                    return false;
                }
                if (this.shouldSuppressOfferForNonProduction()) {
                    this.rejectSavedPlaceOfferForNonProduction(pending.scheduled_communication_id);
                    return false;
                }

                const scId = pending.scheduled_communication_id;
                if ((this.acceptSavedPlaceDialog || this.isProcessingAcceptSavedPlaceCall) &&
                    this.pendingSavedPlaceCall?.scheduled_communication_id === scId) {
                    this.clearQueuedPendingSavedPlaceCall();
                    return false;
                }
                if (this.queuedPendingSavedPlaceCallId > 0 && this.queuedPendingSavedPlaceCallId !== scId) {
                    this.clearQueuedPendingSavedPlaceCall({ decline: true });
                }

                this.queuedPendingSavedPlaceCall = pending;
                this.queuedPendingSavedPlaceCallId = scId;
                this.queuedPendingSavedPlaceCallQueuedAt = Date.now();
                this.clearRecoverOfferingSavedPlaceCallAcceptUISchedule();
                this.armQueuedPendingSavedPlaceCallTtl();
                return true;
            },
            onPushInboundCallToUser(response) {

                // Verify not a supervisor trying to barge/listen/coach
                if (this.isSupervisor) {
                    return;
                }

                const data = response?.Data;
                if (!data) {
                    return;
                }

                // VE-10188: wrap-up/teardown can block the offer — queue and flush when busy clears.
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    this.queuePendingIncomingCall(data);
                    return;
                }

                this.openPendingIncomingCall(data);
            },
            onPushInternalCallTransferToUser(response) {

                // Verify not a supervisor trying to barge/listen/coach
                if (this.isSupervisor) {
                    return;
                }

                const data = response?.Data;
                if (!data) {
                    return;
                }

                // VE-10478: wrap-up/teardown can block the offer — queue and flush when busy clears.
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    this.queuePendingCallTransfer(data);
                    return;
                }

                this.openPendingCallTransfer(data);
            },
            onPushSavedPlaceCallToUser(response) {

                // verify not a supervisor tryping to barge/listen/coach
                if (this.isSupervisor) {
                    return;
                }

                const data = response?.Data;
                if (!(data?.scheduled_communication_id > 0)) {
                    return;
                }

                // VE-10478: wrap-up/teardown can block the offer — queue and flush when busy clears.
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    this.queuePendingSavedPlaceCall(data);
                    return;
                }

                this.openPendingSavedPlaceCall(data);
            },
            openTransferDialog(destination, location, type, destinationID, toNumber, toExtension) {
                this.forceTransferDialog = {
                    destination: destination,
                    destinationId: destinationID,
                    location: location,
                    toExtension: toExtension || null,
                    toNumber: toNumber,
                    type: type,
                }
            },
            openVinLoginDecisionDialog() {
                this.bus.send({ type: "vinSolutionsLoginDecisionRequired" }, { source: "call_screen" });
            },
            pauseForVinLoginDecisionIfSafe() {
                if (this.isSupervisor || this.onCall || this.validCallId || this.currentAgent?.agent_status_name === "Pause") {
                    return;
                }

                this.createAgentForPause();
            },
            finishGetNextChain(options) {
                this.clearGetNextInFlightTimeout();
                this.getNextInFlight = false;
                // skipParentClear: Available mint still outstanding after unmount (VE-10320).
                if (!options?.skipParentClear && typeof this.setGetNextInFlight === 'function') {
                    this.setGetNextInFlight(false);
                }
                // nextTick so a synchronous getNext(null) after finish (e.g. completeSaveAndNext)
                // owns the chain before any deferred flush runs.
                if (!options?.skipFlush) {
                    Vue.nextTick(() => {
                        this.flushGetNextPending();
                        this.flushQueuedOffers();
                    });
                }
            },
            clearAcceptInFlightTimeout() {
                if (this.acceptInFlightTimeoutId !== null) {
                    clearTimeout(this.acceptInFlightTimeoutId);
                    this.acceptInFlightTimeoutId = null;
                }
            },
            clearGetNextInFlightTimeout() {
                if (this.getNextInFlightTimeoutId !== null) {
                    clearTimeout(this.getNextInFlightTimeoutId);
                    this.getNextInFlightTimeoutId = null;
                }
            },
            // Remember that getNext(null) was requested but could not start. Flushed when blockers clear.
            queueGetNext() {
                this.getNextPending = true;
            },
            // Statuses where createAgentForAvailable refuses — keep pending, do not re-enter getNext (VE-9959).
            isAgentStatusBlockingAutoAvailable() {
                const statusName = this.currentAgent?.agent_status_name;
                return [
                    "Inbound Wrap Up",
                    "Incoming Call",
                    "Outbound Wrap Up",
                    "Outgoing Call",
                    "Phone - Accepted Incoming Call",
                    "Phone - Accepted Incoming Call Transfer",
                    "Phone - Accepted Saved Place Call",
                ].indexOf(statusName) >= 0;
            },
            // Run a deferred getNext once it is safe. Drops the intent if the agent left production idle.
            flushGetNextPending() {
                if (!this.getNextPending) {
                    return;
                }
                if (this.getNextInFlight || this.isBusyWithLiveOrAcceptingCall() || this.vinLoginDecisionPending) {
                    return;
                }
                // Hold pending through wrap-up / live statuses so finishGetNextChain cannot busy-loop getNext.
                if (this.isAgentStatusBlockingAutoAvailable()) {
                    return;
                }
                // Fail-safe: do not auto-serve while the agent is intentionally idle.
                if (this.isAgentInNonProductionStatus()) {
                    this.getNextPending = false;
                    return;
                }
                // Already have a customer — deferred request is satisfied.
                if (this.validCampaignCustomerActiveID) {
                    this.getNextPending = false;
                    return;
                }
                this.getNext(null);
            },
            clearQueuedPendingIncomingCallTtl() {
                if (this.queuedPendingIncomingCallTtlTimeoutId !== null) {
                    clearTimeout(this.queuedPendingIncomingCallTtlTimeoutId);
                    this.queuedPendingIncomingCallTtlTimeoutId = null;
                }
            },
            armQueuedPendingIncomingCallTtl() {
                this.clearQueuedPendingIncomingCallTtl();
                this.queuedPendingIncomingCallTtlTimeoutId = setTimeout(() => {
                    this.queuedPendingIncomingCallTtlTimeoutId = null;
                    if (!this.queuedPendingIncomingCall) {
                        return;
                    }
                    if (this.isQueuedPendingIncomingCallExpired()) {
                        this.clearQueuedPendingIncomingCall({ decline: true });
                    }
                }, QUEUED_PENDING_INCOMING_CALL_TTL_MS);
            },
            isQueuedPendingIncomingCallExpired() {
                if (!(this.queuedPendingIncomingCallQueuedAt > 0)) {
                    return false;
                }
                return (Date.now() - this.queuedPendingIncomingCallQueuedAt) >= QUEUED_PENDING_INCOMING_CALL_TTL_MS;
            },
            clearQueuedPendingCallTransferTtl() {
                if (this.queuedPendingCallTransferTtlTimeoutId !== null) {
                    clearTimeout(this.queuedPendingCallTransferTtlTimeoutId);
                    this.queuedPendingCallTransferTtlTimeoutId = null;
                }
            },
            armQueuedPendingCallTransferTtl() {
                this.clearQueuedPendingCallTransferTtl();
                this.queuedPendingCallTransferTtlTimeoutId = setTimeout(() => {
                    this.queuedPendingCallTransferTtlTimeoutId = null;
                    if (!this.queuedPendingCallTransfer) {
                        return;
                    }
                    if ((this.acceptCallTransferDialog || this.isProcessingAcceptCallTransfer) &&
                        this.pendingCallTransfer?.call_transfer?.id === this.queuedPendingCallTransferId) {
                        this.clearQueuedPendingCallTransfer();
                        return;
                    }
                    // Keep holding while the agent is still on the call this transfer came from, so
                    // flushQueuedOffers can open it once they are free. Holding also keeps the offer in
                    // client state, so window close / destroy still release it.
                    if (this.isBusyWithLiveOrAcceptingCall() && !this.isQueuedPendingCallTransferHoldExpired()) {
                        this.armQueuedPendingCallTransferTtl();
                        return;
                    }
                    if (this.isQueuedPendingCallTransferExpired()) {
                        this.clearQueuedPendingCallTransfer({ decline: true });
                    }
                }, QUEUED_PENDING_INCOMING_CALL_TTL_MS);
            },
            isQueuedPendingCallTransferExpired() {
                if (!(this.queuedPendingCallTransferQueuedAt > 0)) {
                    return false;
                }
                return (Date.now() - this.queuedPendingCallTransferQueuedAt) >= QUEUED_PENDING_INCOMING_CALL_TTL_MS;
            },
            isQueuedPendingCallTransferHoldExpired() {
                if (!(this.queuedPendingCallTransferQueuedAt > 0)) {
                    return false;
                }
                return (Date.now() - this.queuedPendingCallTransferQueuedAt) >= QUEUED_PENDING_CALL_TRANSFER_MAX_HOLD_MS;
            },
            clearQueuedPendingSavedPlaceCallTtl() {
                if (this.queuedPendingSavedPlaceCallTtlTimeoutId !== null) {
                    clearTimeout(this.queuedPendingSavedPlaceCallTtlTimeoutId);
                    this.queuedPendingSavedPlaceCallTtlTimeoutId = null;
                }
            },
            armQueuedPendingSavedPlaceCallTtl() {
                this.clearQueuedPendingSavedPlaceCallTtl();
                this.queuedPendingSavedPlaceCallTtlTimeoutId = setTimeout(() => {
                    this.queuedPendingSavedPlaceCallTtlTimeoutId = null;
                    if (!this.queuedPendingSavedPlaceCall) {
                        return;
                    }
                    if ((this.acceptSavedPlaceDialog || this.isProcessingAcceptSavedPlaceCall) &&
                        this.pendingSavedPlaceCall?.scheduled_communication_id === this.queuedPendingSavedPlaceCallId) {
                        this.clearQueuedPendingSavedPlaceCall();
                        return;
                    }
                    if (this.isQueuedPendingSavedPlaceCallExpired()) {
                        this.clearQueuedPendingSavedPlaceCall({ decline: true });
                    }
                }, QUEUED_PENDING_INCOMING_CALL_TTL_MS);
            },
            isQueuedPendingSavedPlaceCallExpired() {
                if (!(this.queuedPendingSavedPlaceCallQueuedAt > 0)) {
                    return false;
                }
                return (Date.now() - this.queuedPendingSavedPlaceCallQueuedAt) >= QUEUED_PENDING_INCOMING_CALL_TTL_MS;
            },
            clearStaleOfferingCallStatus() {
                if (this.currentAgent?.agent_status_name !== "Offering Call") {
                    return;
                }
                if (this.acceptIncomingCallDialog || this.validPendingIncomingCall || this.queuedPendingIncomingCall) {
                    return;
                }
                if (this.acceptCallTransferDialog || this.validPendingCallTransfer || this.queuedPendingCallTransfer) {
                    return;
                }
                return this.afterOfferDecline(this.intendedNonProductionStatusName);
            },
            clearStaleOfferingSavedPlaceCallStatus() {
                if (this.currentAgent?.agent_status_name !== "Offering Saved Place Call") {
                    return;
                }
                if (this.acceptSavedPlaceDialog || this.validPendingSavedPlaceCall || this.queuedPendingSavedPlaceCall) {
                    return;
                }
                return this.afterOfferDecline(this.intendedNonProductionStatusName);
            },
            flushQueuedOffers() {
                this.flushQueuedPendingCallTransfer();
                this.flushQueuedPendingSavedPlaceCall();
                this.flushQueuedPendingIncomingCall();
            },
            releaseQueuedInboundOffer(ccqId) {
                if (!(ccqId > 0)) {
                    return;
                }
                const intendedRestore = this.intendedNonProductionStatusName;
                const shouldRestoreAfterDecline = this.currentAgent?.agent_status_name === "Offering Call";
                DeclineIncomingCall(ccqId, {
                    agent_clicked_decline: false,
                    attempt_key: this.currentAgent?.attempt_key,
                    skip_create_ignore_call: true,
                    skip_create_declined_agent: true,
                }).then(() => {
                    if (shouldRestoreAfterDecline) {
                        return this.afterOfferDecline(intendedRestore);
                    }
                }).catch(() => {
                    console.error("releaseQueuedInboundOffer failed", ccqId);
                    if (shouldRestoreAfterDecline) {
                        return this.afterOfferDecline(intendedRestore);
                    }
                });
            },
            clearQueuedPendingIncomingCall(options = {}) {
                const decline = options.decline === true;
                const ccqId = this.queuedPendingIncomingCallCcqId;
                this.clearQueuedPendingIncomingCallTtl();
                this.queuedPendingIncomingCall = null;
                this.queuedPendingIncomingCallCcqId = null;
                this.queuedPendingIncomingCallQueuedAt = null;
                if (decline && ccqId > 0) {
                    this.releaseQueuedInboundOffer(ccqId);
                }
            },
            flushQueuedPendingIncomingCall() {
                if (!this.queuedPendingIncomingCall) {
                    return;
                }
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    return;
                }
                if (this.acceptIncomingCallDialog || this.validPendingIncomingCall) {
                    this.clearQueuedPendingIncomingCall({ decline: true });
                    return;
                }
                if (this.isQueuedPendingIncomingCallExpired()) {
                    this.clearQueuedPendingIncomingCall({ decline: true });
                    return;
                }
                if (this.flushQueuedPendingIncomingCallInFlight) {
                    return;
                }

                const ccqId = this.queuedPendingIncomingCallCcqId;
                this.clearQueuedPendingIncomingCall();

                // Reclaim from API — do not open a frozen websocket payload that may be dead after wrap-up.
                this.flushQueuedPendingIncomingCallInFlight = true;
                this.reclaimNextInboundOffer().then((response) => {
                    if (isAssignNextInboundCallEmpty(response?.Data)) {
                        if (this.currentAgent?.agent_status_name === "Offering Call" && ccqId > 0) {
                            this.releaseQueuedInboundOffer(ccqId);
                        }
                        return;
                    }
                    if (response?.Error) {
                        console.error("flushQueuedPendingIncomingCall reclaim failed", response.Error);
                        return;
                    }

                    const ccq = response?.Data?.call_communication_queue;
                    const pending = response?.Data?.pending_incoming_call;
                    if (!(pending?.call_communication_queue?.call_communication_queue_id > 0)) {
                        if (ccq?.id > 0 && ccq?.status === "pending" && ccq?.id === ccqId) {
                            this.scheduleRecoverOfferingCallAcceptUI();
                        } else if (this.currentAgent?.agent_status_name === "Offering Call" && ccqId > 0) {
                            this.releaseQueuedInboundOffer(ccqId);
                        }
                        return;
                    }

                    if (!ccq?.already_pending || ccq?.id !== ccqId) {
                        console.debug("flushQueuedPendingIncomingCall: reclaim miss for queued ccq, skipping stale open");
                        if (this.currentAgent?.agent_status_name === "Offering Call" && ccqId > 0) {
                            this.releaseQueuedInboundOffer(ccqId);
                        }
                        return;
                    }

                    this.handleAssignNextInboundCallResult(response.Data);
                }).catch((err) => {
                    console.error("flushQueuedPendingIncomingCall reclaim failed", err);
                }).finally(() => {
                    this.flushQueuedPendingIncomingCallInFlight = false;
                });
            },
            releaseQueuedCallTransferOffer(callTransferId) {
                if (!(callTransferId > 0)) {
                    return;
                }
                const intendedRestore = this.intendedNonProductionStatusName;
                const shouldRestoreAfterDecline = this.currentAgent?.agent_status_name === "Offering Call";
                DeclineCallTransfer(callTransferId, {
                    agent_clicked_decline: false,
                    attempt_key: this.currentAgent?.attempt_key,
                    skip_create_declined_agent: true,
                }).then(() => {
                    if (shouldRestoreAfterDecline) {
                        return this.afterOfferDecline(intendedRestore);
                    }
                }).catch(() => {
                    console.error("releaseQueuedCallTransferOffer failed", callTransferId);
                    if (shouldRestoreAfterDecline) {
                        return this.afterOfferDecline(intendedRestore);
                    }
                });
            },
            clearQueuedPendingCallTransfer(options = {}) {
                const decline = options.decline === true;
                const transferId = this.queuedPendingCallTransferId;
                this.clearQueuedPendingCallTransferTtl();
                this.queuedPendingCallTransfer = null;
                this.queuedPendingCallTransferId = null;
                this.queuedPendingCallTransferQueuedAt = null;
                if (decline && transferId > 0) {
                    this.releaseQueuedCallTransferOffer(transferId);
                }
            },
            flushQueuedPendingCallTransfer() {
                if (!this.queuedPendingCallTransfer) {
                    return;
                }
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    return;
                }
                if (this.acceptCallTransferDialog || this.validPendingCallTransfer) {
                    this.clearQueuedPendingCallTransfer({ decline: true });
                    return;
                }
                // Bound on max hold, not the TTL: the TTL re-arms while the agent is still on the
                // call the transfer came from, and reclaim below re-fetches rather than opening the
                // frozen payload, so age alone is not a reason to drop it.
                if (this.isQueuedPendingCallTransferHoldExpired()) {
                    this.clearQueuedPendingCallTransfer({ decline: true });
                    return;
                }
                if (this.flushQueuedPendingCallTransferInFlight) {
                    return;
                }

                const transferId = this.queuedPendingCallTransferId;
                this.clearQueuedPendingCallTransfer();

                this.flushQueuedPendingCallTransferInFlight = true;
                AssignNextInboundCallTransfer({ reclaim_only: true }).then((response) => {
                    if (isAssignNextCallTransferEmpty(response?.Data)) {
                        if (this.currentAgent?.agent_status_name === "Offering Call" && transferId > 0) {
                            this.releaseQueuedCallTransferOffer(transferId);
                        }
                        return;
                    }
                    if (response?.Error) {
                        console.error("flushQueuedPendingCallTransfer reclaim failed", response.Error);
                        return;
                    }

                    const pending = response?.Data?.pending_internal_call_transfer;
                    const callTransfer = response?.Data?.call_transfer;
                    if (!(pending?.call_transfer?.id > 0)) {
                        if (callTransfer?.id > 0 && callTransfer?.transfer_status === "pending" && callTransfer?.id === transferId) {
                            this.scheduleRecoverOfferingCallAcceptUI();
                        } else if (this.currentAgent?.agent_status_name === "Offering Call" && transferId > 0) {
                            this.releaseQueuedCallTransferOffer(transferId);
                        }
                        return;
                    }

                    if (pending.call_transfer.id !== transferId) {
                        console.debug("flushQueuedPendingCallTransfer: reclaim miss for queued transfer, skipping stale open");
                        if (this.currentAgent?.agent_status_name === "Offering Call" && transferId > 0) {
                            this.releaseQueuedCallTransferOffer(transferId);
                        }
                        return;
                    }

                    this.handleAssignNextCallTransferResult(response.Data);
                }).catch((err) => {
                    console.error("flushQueuedPendingCallTransfer reclaim failed", err);
                }).finally(() => {
                    this.flushQueuedPendingCallTransferInFlight = false;
                });
            },
            releaseQueuedSavedPlaceOffer(scheduledCommunicationId) {
                if (!(scheduledCommunicationId > 0)) {
                    return;
                }
                const intendedRestore = this.intendedNonProductionStatusName;
                const shouldRestoreAfterDecline = this.currentAgent?.agent_status_name === "Offering Saved Place Call";
                DeclineSavedPlaceCall(scheduledCommunicationId, {
                    agentClickedDecline: false,
                    attempt_key: this.currentAgent?.attempt_key,
                    skip_create_declined_agent: true,
                }).then(() => {
                    if (shouldRestoreAfterDecline) {
                        return this.afterOfferDecline(intendedRestore);
                    }
                }).catch(() => {
                    console.error("releaseQueuedSavedPlaceOffer failed", scheduledCommunicationId);
                    if (shouldRestoreAfterDecline) {
                        return this.afterOfferDecline(intendedRestore);
                    }
                });
            },
            clearQueuedPendingSavedPlaceCall(options = {}) {
                const decline = options.decline === true;
                const scId = this.queuedPendingSavedPlaceCallId;
                this.clearQueuedPendingSavedPlaceCallTtl();
                this.queuedPendingSavedPlaceCall = null;
                this.queuedPendingSavedPlaceCallId = null;
                this.queuedPendingSavedPlaceCallQueuedAt = null;
                if (decline && scId > 0) {
                    this.releaseQueuedSavedPlaceOffer(scId);
                }
            },
            flushQueuedPendingSavedPlaceCall() {
                if (!this.queuedPendingSavedPlaceCall) {
                    return;
                }
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    return;
                }
                if (this.acceptSavedPlaceDialog || this.validPendingSavedPlaceCall) {
                    this.clearQueuedPendingSavedPlaceCall({ decline: true });
                    return;
                }
                if (this.isQueuedPendingSavedPlaceCallExpired()) {
                    this.clearQueuedPendingSavedPlaceCall({ decline: true });
                    return;
                }
                if (this.flushQueuedPendingSavedPlaceCallInFlight) {
                    return;
                }

                const scId = this.queuedPendingSavedPlaceCallId;
                this.clearQueuedPendingSavedPlaceCall();

                this.flushQueuedPendingSavedPlaceCallInFlight = true;
                AssignNextSavedPlaceInLine({ reclaim_only: true }).then((response) => {
                    if (isAssignNextSavedPlaceInLineEmpty(response?.Data)) {
                        if (this.currentAgent?.agent_status_name === "Offering Saved Place Call" && scId > 0) {
                            this.releaseQueuedSavedPlaceOffer(scId);
                        }
                        return;
                    }
                    if (response?.Error) {
                        console.error("flushQueuedPendingSavedPlaceCall reclaim failed", response.Error);
                        return;
                    }

                    const pending = response?.Data?.pending_saved_place_call;
                    if (!(pending?.scheduled_communication_id > 0)) {
                        if (this.currentAgent?.agent_status_name === "Offering Saved Place Call" && scId > 0) {
                            this.releaseQueuedSavedPlaceOffer(scId);
                        }
                        return;
                    }

                    if (pending.scheduled_communication_id !== scId) {
                        console.debug("flushQueuedPendingSavedPlaceCall: reclaim miss for queued saved place, skipping stale open");
                        if (this.currentAgent?.agent_status_name === "Offering Saved Place Call" && scId > 0) {
                            this.releaseQueuedSavedPlaceOffer(scId);
                        }
                        return;
                    }

                    this.handleAssignNextSavedPlaceResult(response.Data);
                }).catch((err) => {
                    console.error("flushQueuedPendingSavedPlaceCall reclaim failed", err);
                }).finally(() => {
                    this.flushQueuedPendingSavedPlaceCallInFlight = false;
                });
            },
            // VE-9959: leave Finished / hang-tight by re-arming get-next when the agent is idle and servable.
            recoverGetNextAfterStuckProductionStatus() {
                if (this.isSupervisor) {
                    return;
                }
                if (this.isAgentInNonProductionStatus()) {
                    return;
                }
                if (this.validCampaignCustomerActiveID) {
                    return;
                }
                if (this.getNextInFlight || this.isBusyWithLiveOrAcceptingCall() || this.vinLoginDecisionPending) {
                    this.queueGetNext();
                    return;
                }
                // VE-10188: manual outbound-only — restore search UI without running get-next into hang tight.
                // manualModeInbound must still run steps 1–4 (transfers, inbound, etc.); step 5 restores manual UI.
                if (this.isManualMode && this.manualModeCampaign?.campaign_id > 0 && !this.manualModeInbound) {
                    this.getNextPending = false;
                    this.finishGetNextChain();
                    this.enterManualMode(this.manualModeCampaign, null, this.manualModeEnrollAsEligible, null, null);
                    return;
                }
                this.queueGetNext();
                this.flushGetNextPending();
            },
            // VE-10477: Accept* never settled. Clear the processing flag so get-next / inbound
            // recovery can run. Record the get-next intent but do not start a chain here — the server
            // may already have accepted. currentAgentTimer flushes it once the screen has settled.
            recoverAfterStuckAcceptInFlight(generation) {
                if (generation !== this.acceptInFlightGeneration) {
                    return;
                }
                if (!this.isProcessingAcceptIncomingCall && !this.isProcessingAcceptCallTransfer && !this.isProcessingAcceptSavedPlaceCall) {
                    return;
                }

                this.acceptInFlightGeneration += 1;

                const wasIncoming = this.isProcessingAcceptIncomingCall;
                const wasTransfer = this.isProcessingAcceptCallTransfer;
                this.isProcessingAcceptIncomingCall = false;
                this.isProcessingAcceptCallTransfer = false;
                this.isProcessingAcceptSavedPlaceCall = false;

                if (wasIncoming) {
                    this.pendingIncomingCall = null;
                    this.showSnackbar("error", "An error occurred while accepting the call");
                } else if (wasTransfer) {
                    this.showSnackbar("error", "An error occurred while accepting the call transfer");
                } else {
                    this.showSnackbar("error", "An error occurred while accepting the saved place call");
                }

                this.finishGetNextChain({ skipFlush: true });
                this.queueGetNext();
            },
            // VE-10473: accept commits the agent status server-side before the screen hydrates, so an
            // aborted hydration strands the agent in an accepted status with no call and no offer left to
            // reclaim. A live call always reports busy below, so only the wedged case reaches get-next.
            recoverAfterStuckAcceptedCall() {
                if (this.isSupervisor) {
                    return;
                }
                const accepted = [
                    "Phone - Accepted Incoming Call",
                    "Phone - Accepted Incoming Call Transfer",
                    "Phone - Accepted Saved Place Call",
                ].indexOf(this.currentAgent?.agent_status_name) >= 0;
                if (!accepted) {
                    return;
                }
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    return;
                }
                this.recoverGetNextAfterStuckProductionStatus();
            },
            // VE-10475: accept-scoped. Softphone Incoming/Outgoing Call or onCall means the call landed —
            // cancel. forceCall from the offer is not proof: hydration copies it even when the caller is gone.
            armStuckAcceptedCallTimeout() {
                this.clearStuckAcceptedCallTimeout();
                this.stuckAcceptedCallTimeoutId = setTimeout(() => {
                    this.stuckAcceptedCallTimeoutId = null;
                    this.recoverAfterStuckAcceptedCallHydration();
                }, STUCK_ACCEPTED_CALL_TIMEOUT_MS);
            },
            clearStuckAcceptedCallTimeout() {
                if (this.stuckAcceptedCallTimeoutId !== null) {
                    clearTimeout(this.stuckAcceptedCallTimeoutId);
                    this.stuckAcceptedCallTimeoutId = null;
                }
            },
            recoverAfterStuckAcceptedCallHydration() {
                if (this.isSupervisor) {
                    return;
                }
                if (this.isAgentInNonProductionStatus()) {
                    // Already Break/Pause — do not force Available. Drop the sticky flag so get-next can run when they return.
                    this.isHandlingInboundCall = false;
                    return;
                }
                if (this.isProcessingAcceptIncomingCall || this.isProcessingAcceptCallTransfer || this.isProcessingAcceptSavedPlaceCall) {
                    return;
                }
                if (this.acceptIncomingCallDialog || this.acceptCallTransferDialog || this.acceptSavedPlaceDialog) {
                    return;
                }
                if (this.acceptedCallHasLiveProof) {
                    return;
                }
                // Desk phones never set onCall or Incoming Call. A non-failed call record may still be live.
                if (this.isNonBrowserDevice && !this.callFailed && (this.forceCall?.id > 0 || this.validCallId)) {
                    return;
                }
                const accepted = [
                    "Phone - Accepted Incoming Call",
                    "Phone - Accepted Incoming Call Transfer",
                    "Phone - Accepted Saved Place Call",
                ].indexOf(this.currentAgent?.agent_status_name) >= 0;
                if (!accepted) {
                    this.isHandlingInboundCall = false;
                    return;
                }
                // Clears isHandlingInboundCall and the offer's stale forceCall so getNext is not still busy.
                this.resetCurrentCampaignCustomerDefaults(false);
                this.clearIntendedNonProductionStatus();
                this.queueGetNext();
                // VE-10320: the server offer gates read the agent record, so get-next must wait for
                // the Available mint to settle instead of racing it.
                Promise.resolve(this.createAgent({ status_name: "Available" })).finally(() => {
                    if (this._isDestroyed === true) {
                        return;
                    }
                    this.getNext(null);
                });
            },
            clearRecoverOfferingCallAcceptUISchedule() {
                if (this.recoverOfferingCallAcceptUiTimeoutId !== null) {
                    clearTimeout(this.recoverOfferingCallAcceptUiTimeoutId);
                    this.recoverOfferingCallAcceptUiTimeoutId = null;
                }
            },
            scheduleRecoverOfferingCallAcceptUI() {
                this.clearRecoverOfferingCallAcceptUISchedule();
                this.recoverOfferingCallAcceptUiTimeoutId = setTimeout(() => {
                    this.recoverOfferingCallAcceptUiTimeoutId = null;
                    this.recoverOfferingCallAcceptUI();
                }, RECOVER_OFFERING_CALL_ACCEPT_UI_DELAY_MS);
            },
            clearRecoverOfferingSavedPlaceCallAcceptUISchedule() {
                if (this.recoverOfferingSavedPlaceCallAcceptUiTimeoutId !== null) {
                    clearTimeout(this.recoverOfferingSavedPlaceCallAcceptUiTimeoutId);
                    this.recoverOfferingSavedPlaceCallAcceptUiTimeoutId = null;
                }
            },
            scheduleRecoverOfferingSavedPlaceCallAcceptUI() {
                this.clearRecoverOfferingSavedPlaceCallAcceptUISchedule();
                this.recoverOfferingSavedPlaceCallAcceptUiTimeoutId = setTimeout(() => {
                    this.recoverOfferingSavedPlaceCallAcceptUiTimeoutId = null;
                    this.recoverOfferingSavedPlaceCallAcceptUI();
                }, RECOVER_OFFERING_CALL_ACCEPT_UI_DELAY_MS);
            },
            reclaimNextInboundOffer() {
                return ReclaimNextInboundOffer();
            },
            recoverOfferingCallAcceptUI() {
                if (this.isSupervisor) {
                    return;
                }
                if (this.recoverOfferingCallInFlight) {
                    return;
                }
                if (this.acceptIncomingCallDialog || this.validPendingIncomingCall) {
                    return;
                }
                if (this.acceptCallTransferDialog || this.validPendingCallTransfer) {
                    return;
                }
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    return;
                }
                if (this.currentAgent?.agent_status_name !== "Offering Call") {
                    return;
                }
                if (!this.hasLoggedInQueues) {
                    return;
                }
                if (this.shouldSuppressOfferForNonProduction()) {
                    return;
                }

                this.recoverOfferingCallInFlight = true;
                const reclaimInbound = () => {
                    if (!this.isInboundEligible) {
                        this.clearStaleOfferingCallStatus();
                        return Promise.resolve();
                    }
                    return this.reclaimNextInboundOffer().then((response) => {
                        if (isAssignNextInboundCallEmpty(response?.Data)) {
                            console.debug("recoverOfferingCallAcceptUI: no pending inbound or transfer to reclaim");
                            this.clearStaleOfferingCallStatus();
                            return;
                        }
                        if (response?.Error) {
                            console.error("recoverOfferingCallAcceptUI failed", response.Error);
                            this.showSnackbar("error", "Unable to load incoming call offer. Please refresh if your status looks wrong.");
                            return;
                        }
                        if (response?.Data?.pending_incoming_call) {
                            this.handleAssignNextInboundCallResult(response.Data);
                            return;
                        }
                        this.clearStaleOfferingCallStatus();
                    }).catch((err) => {
                        console.error("recoverOfferingCallAcceptUI failed", err);
                        this.showSnackbar("error", "Unable to load incoming call offer. Please refresh if your status looks wrong.");
                    });
                };
                // Reclaim-only: repairing a stale Offering Call must not consume a transfer queued for another agent.
                AssignNextInboundCallTransfer({ reclaim_only: true }).then((transferResponse) => {
                    if (!isAssignNextCallTransferEmpty(transferResponse?.Data) && !transferResponse?.Error) {
                        this.handleAssignNextCallTransferResult(transferResponse.Data);
                        return;
                    }
                    return reclaimInbound();
                }).catch(() => {
                    return reclaimInbound();
                }).finally(() => {
                    this.recoverOfferingCallInFlight = false;
                });
            },
            recoverOfferingSavedPlaceCallAcceptUI() {
                if (this.isSupervisor) {
                    return;
                }
                if (this.recoverOfferingSavedPlaceCallInFlight) {
                    return;
                }
                if (this.acceptSavedPlaceDialog || this.validPendingSavedPlaceCall) {
                    return;
                }
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    return;
                }
                if (this.currentAgent?.agent_status_name !== "Offering Saved Place Call") {
                    return;
                }
                if (!this.isInboundEligible || !this.hasLoggedInQueues) {
                    return;
                }
                if (this.shouldSuppressOfferForNonProduction()) {
                    return;
                }

                this.recoverOfferingSavedPlaceCallInFlight = true;
                // Reclaim-only: repairing a stale offer must not claim a callback waiting for another agent.
                AssignNextSavedPlaceInLine({ reclaim_only: true }).then((response) => {
                    if (isAssignNextSavedPlaceInLineEmpty(response?.Data)) {
                        console.debug("recoverOfferingSavedPlaceCallAcceptUI: no pending saved place to reclaim");
                        this.clearStaleOfferingSavedPlaceCallStatus();
                        return;
                    }
                    if (response?.Error) {
                        console.error("recoverOfferingSavedPlaceCallAcceptUI failed", response.Error);
                        this.showSnackbar("error", "Unable to load saved place offer. Please refresh if your status looks wrong.");
                        return;
                    }
                    if (response?.Data?.pending_saved_place_call) {
                        this.handleAssignNextSavedPlaceResult(response.Data);
                        return;
                    }
                    this.clearStaleOfferingSavedPlaceCallStatus();
                }).catch((err) => {
                    console.error("recoverOfferingSavedPlaceCallAcceptUI failed", err);
                    this.showSnackbar("error", "Unable to load saved place offer. Please refresh if your status looks wrong.");
                }).finally(() => {
                    this.recoverOfferingSavedPlaceCallInFlight = false;
                });
            },
            // VE-10477: if Accept* hangs, recoverAfterStuckAcceptInFlight unlocks the agent.
            // Bump acceptInFlightGeneration so a late response cannot hydrate after timeout.
            armAcceptInFlightTimeout(generation) {
                this.clearAcceptInFlightTimeout();
                this.acceptInFlightTimeoutId = setTimeout(() => {
                    this.acceptInFlightTimeoutId = null;
                    this.recoverAfterStuckAcceptInFlight(generation);
                }, ACCEPT_IN_FLIGHT_TIMEOUT_MS);
            },
            // Safety net: if a getNext step hangs (network stall, missed finish), clear inflight
            // and bump chainId so a late response cannot resume the abandoned chain.
            armGetNextInFlightTimeout(chainId) {
                this.clearGetNextInFlightTimeout();
                this.getNextInFlightTimeoutId = setTimeout(() => {
                    this.getNextInFlightTimeoutId = null;
                    if (!this.getNextInFlight || chainId !== this.getNextChainId) {
                        return;
                    }
                    this.getNextChainId += 1;
                    this.isLoading = false;
                    // Unlock and retry — timeout alone left agents on hang-tight with no re-arm.
                    this.queueGetNext();
                    this.finishGetNextChain();
                }, 60000);
            },
            runContinueAfterSaveAndNext() {
                this.finishGetNextChain();
                // VE-10188: manual outbound-only — restore search UI without running get-next into hang tight.
                // manualModeInbound must still run steps 1–4 (transfers, inbound, etc.); step 5 restores manual UI.
                if (this.isManualMode && this.manualModeCampaign?.campaign_id > 0 && !this.manualModeInbound) {
                    this.clearSaveAndNextWrapUpSkip();
                    this.enterManualMode(this.manualModeCampaign, null, this.manualModeEnrollAsEligible, null, null);
                    return;
                }
                this.getNext(null);
            },
            armSaveAndNextWrapUpSkip() {
                // Scope the skip to the disposed call so a later call still mints its own wrap up.
                // calls.id is never reused, so the arm can outlive the teardown it is waiting on.
                this.saveAndNextWrapUpSkipCallId = this.call?.id || 0;
                if (!(this.saveAndNextWrapUpSkipCallId > 0)) {
                    console.debug("armSaveAndNextWrapUpSkip: no call id — stale wrap-up skip not armed");
                }
            },
            clearSaveAndNextWrapUpSkip() {
                this.saveAndNextWrapUpSkipCallId = 0;
            },
            shouldSkipWrapUpForGetNextAdvance(callId) {
                if (!(callId > 0) || callId !== this.saveAndNextWrapUpSkipCallId) {
                    return false;
                }
                // Only suppress once get-next actually advanced. A failed get-next still needs its wrap up:
                // Outgoing Call blocks auto-Available and has no suspicious-status recovery timer.
                return this.validCampaignCustomerActiveID;
            },
            finishSaveAndNextOverlay() {
                this.initiateCreateCommunicationDisposition = false;
                this.turnFullScreenOverlayOff?.();
            },
            completeSaveAndNext() {

                console.debug("completeSaveAndNext: 1");
                try {
                    // Verify
                    if (!this.saveAndNextAction) {
                        return;
                    }

                    // Remove campaign customer from slice and unset from current
                    // We do not need to run an update here because it already happens on the backend

                    console.debug("completeSaveAndNext: 2");
                    // Ensure we have a current with at least a campaign ID (reception mode won't have a cc active ID)
                    if (!(this.currentCampaignCustomer?.campaign_id > 0)) {
                        return;
                    }

                    console.debug("completeSaveAndNext: 3");
                    // Remove from campaign customers
                    if (this.campaignCustomers?.length > 0) {

                        // Find idx where cc active ID equals or is null
                        const idx = this.campaignCustomers.findIndex(i => (i.campaign_customer_active_id > 0 && i.campaign_customer_active_id === this.currentCampaignCustomer?.campaign_customer_active_id) || !(i.campaign_customer_active_id > 0));
                        if (idx >= 0) {

                            // Remove from slice
                            this.campaignCustomers.splice(idx, 1);
                        }
                    }

                    console.debug("completeSaveAndNext: 4");
                    // VE-10380: arm before the reset clears this.call so the disposed call id is still available.
                    // Both continue actions run the get-next chain, so both can race a lagging disconnect.
                    if (this.saveAndNextAction === "continue" || this.saveAndNextAction === "continue_and_start") {
                        this.armSaveAndNextWrapUpSkip();
                    }
                    // Set to null and reset
                    this.resetCurrentCampaignCustomerDefaults(false);
                    // Softphone teardown may lag disposition — clear via setOnCall so flush can fire.
                    // Keep this out of the shared reset helper so other sites retain the VE-6502 busy gate.
                    this.setOnCall(false);
                    this.currentCampaignCustomer = null;
                    this.pendingSavedPlaceCall = null;
                    this.isSavedPlaceCall = false;

                    // If taking inbound call from live dash, exit screen on successful save and survey
                    if (this.isLiveDashInboundCall) {
                        this.exitForceCampaignCustomer(true);
                    }

                    // For missed call returns, need to go back to missed call state and clear vmr ONLY if its not a missed call from get next
                    if (this.validVoiceMailRecording && !this.missedCallFromCallScreen) {
                        this.clearSaveAndNextWrapUpSkip();
                        this.endVoiceMailRecording();
                    } else if (this.isPausedVoiceMailRecording) {

                        this.clearSaveAndNextWrapUpSkip();
                        // If voice mail recording ID is actually present even though we do not have a
                        // valid vmr, then it means that they "stopped" the return missed call to take an
                        // inbound call and now that they have finished the inbound call, we need to restart
                        // the missed call

                        // Set current back to null
                        this.currentCampaign = null;
                        this.currentCampaignCustomer = null;
                        this.voiceMailRecording = null;
                        this.pendingSavedPlaceCall = null;
                        this.isSavedPlaceCall = false;
                        this.resetCurrentCampaignCustomerDefaults(false);

                        // Restart vmr
                        this.startVoiceMailRecording();

                    } else if (this.validForceCustomer && this.validEndForceCustomer) {
                        this.clearSaveAndNextWrapUpSkip();
                        this.endForceCustomer();
                    } else {

                        this.voiceMailRecording = null; // set to null here because if we do it earlier with the other cleared values, the call screen will think we're in a paused vmr

                        // Determine next action
                        switch(this.saveAndNextAction) {
                        case "continue":

                            this.runContinueAfterSaveAndNext();
                            this.saveAndNextAction = null;
                            break;

                        case "continue_and_start":

                            this.runContinueAfterSaveAndNext();
                            break;

                        case "stop":

                            // Move user to Pause — do not serve a deferred getNext
                            this.clearSaveAndNextWrapUpSkip();
                            this.getNextPending = false;
                            this.clearDialIntent();
                            this.createAgentForPause();
                            break;

                        }
                    }

                    // only run end voice mail after get next has been called (if we got our voicemail from get next in the first place)
                    if (this.missedCallFromCallScreen) {
                        this.endVoiceMailRecording();
                    }
                } finally {
                    this.finishSaveAndNextOverlay();
                }
                console.debug("completeSaveAndNext: 5");
            },
            createSurveyAttempt(communicationDispositionID) {

                // Verify
                if (!communicationDispositionID || !(this.currentCampaignCustomer?.campaign_id > 0)) {
                    this.finishSaveAndNextOverlay();
                    return;
                }

                // Apply notes from the surveyed disposition if they exist, otherwise fall back to the current notes
                let surveyNotes = null;
                if (this.savedCommunicationDispositions?.length > 0) {
                    surveyNotes = this.savedCommunicationDispositions.find(d => d.communication_disposition_id === communicationDispositionID)?.notes;
                } else if (this.dispositionNotes?.length > 0) {
                    surveyNotes = this.dispositionNotes;
                }

                const options = {
                    attempt_key: this.currentAgent?.attempt_key,
                    campaign_id: this.currentCampaignCustomer?.campaign_id,
                    communication_disposition_id: communicationDispositionID,
                    notes: surveyNotes,
                    survey: this.survey,
                }

                CreateSurveyAttempt(options).then((response) => {
                    if (response?.Data?.survey_attempt?.id > 0) {
                        this.showSnackbar("green", "Successfully saved attempt");
                    }

                    this.completeSaveAndNext();
                }).catch((err) => {
                    console.error("create survey attempt failed", err);
                    this.showSnackbar("error", "Unable to save survey. Please try again.");
                    this.finishSaveAndNextOverlay();
                });
            },
            completeAttemptForInternalTransfer() { // todo - rename

                // Turn on screen overlay
                this.turnFullScreenOverlayOn?.();
                this.saveAndNextAction = "continue";

                this.completeSaveAndNext();
            },
            startSaveAndNext(nextAction) {

                console.debug("startSaveAndNext: 1");
                // If we have already saved a disposition, prepare it for survey
                if (this.savedCommunicationDispositions.length > 0) {
                    console.debug("saved dispositions 1");
                    // If we have multiple dispositions, prioritize them
                    if (this.savedCommunicationDispositions.length > 1 || (this.savedCommunicationDispositions.length > 0 && this.selectedCampaignDisposition)) {
                        console.debug("saved dispositions 2");
                        let dispositionsToPrioritize = this.savedCommunicationDispositions;

                        // If we have a selected disposition, add it to the list to prioritize
                        if (this.selectedCampaignDisposition) {
                            console.debug("saved dispositions 3");
                            dispositionsToPrioritize.push(this.selectedCampaignDisposition);
                        }

                        // Sort by priority
                        this.campaignDispositionToSurvey = dispositionsToPrioritize.sort((a, b) => this.dispositionPrioritiesById[a.disposition_id] - this.dispositionPrioritiesById[b.disposition_id])[0];
                    } else {
                        console.debug("saved dispositions 4");
                        this.campaignDispositionToSurvey = this.savedCommunicationDispositions[0];
                    }
                    // console.debug("campaignDispositionToSurvey: " + this.campaignDispositionToSurvey.disposition_id + " " + this.campaignDispositionToSurvey.disposition_description);
                }

                // Verify we can create survey attempt
                if (!nextAction || (!this.isOkayToCreateCommunicationDisposition && this.selectedCampaignDisposition) || (!this.selectedCampaignDisposition && !this.campaignDispositionToSurvey) || !this.survey) {
                    return;
                }

                console.debug("startSaveAndNext: 2");

                const campaignDispositionIdsThatDenoteSurvey = this.campaignDispositions
                    .filter(d => d.denotes_survey)
                    .map(d => d.disposition_id);


                const hasPreviouslySavedSurveyDisposition = this.savedCommunicationDispositions.some(
                    communicationDisposition => campaignDispositionIdsThatDenoteSurvey.includes(communicationDisposition.disposition_id)
                );

                // Verify that survey is eligible for saving if either the selected campaign disposition or any previously saved disposition denotes a survey
                if (!this.survey.is_save_eligible && (this.selectedCampaignDisposition?.denotes_survey === true || hasPreviouslySavedSurveyDisposition === true)) {
                    this.showSnackbar("error", "All of the required questions must be answered. They are outlined in red.");
                    return;
                }

                console.debug("startSaveAndNext: 3, " + this.initiateCreateCommunicationDisposition);
                // Turn on screen overlay
                this.turnFullScreenOverlayOn?.();
                this.endCall();

                // Create communication disposition
                this.initiateCreateCommunicationDisposition = true;
                this.saveAndNextAction = nextAction;
            },
            setAppointmentIsUniqueIfRequired(value) {
                this.appointmentIsUniqueIfRequired = value;
            },
            setCurrentCampaignFromCurrentCampaignCustomerActive() {

                // ensure valid cc active
                if (!this.validCampaignCustomerActiveID) {
                    return false;
                }

                // Set current campaign
                this.currentCampaign = {
                    account_id: this.currentCampaignCustomer.account_id,
                    campaign_id: this.currentCampaignCustomer.campaign_id,
                    organization_id: this.currentCampaignCustomer.organization_id,
                    organization_time_zone_id: null,
                    campaign_name: this.currentCampaignCustomer?.campaign_name,
                    organization_name: this.communicationManager?.organization_name,
                }
                return true;
            },
            setIntegrationCustomerSid(integrationCustomerSid) {

                // ensure
                if (!this.currentCampaignCustomer) {
                    return;
                }

                // set
                this.currentCampaignCustomer.tekion_customer_sid = integrationCustomerSid;
            },
            stopSwitchCustomer() {
                this.isSwitchingCustomer = false;
            },
            setInitialContactInfoFromCommunicationManager() {

                // ensure valid
                if (!this.communicationManager) {
                    return;
                }

                // init form fields to make it easier
                this.initialFirstName = this.communicationManager?.first_name;
                this.initialLastName = this.communicationManager?.last_name;

                // address
                if (this.communicationManager?.customer_addresses?.length > 0) {
                    this.initialAddress = this.communicationManager.customer_addresses[0];
                }

                // email
                if (this.communicationManager?.customer_email_addresses?.length > 0) {
                    this.initialEmailAddress = this.communicationManager.customer_email_addresses[0].email_address_email;
                }

                // phone number
                if (!(this.initialPhoneNumber?.length > 0) && this.communicationManager?.customer_phone_numbers?.length > 0) {
                    this.initialPhoneNumber = this.communicationManager.customer_phone_numbers[0].phone_number_phone_number;
                }
            },
            startSwitchCustomer() {

                // ensure valid cc active
                if (!this.validCampaignCustomerActiveID || !this.communicationManager) {
                    return;
                }

                // the search create component needs current campaign
                if (!this.setCurrentCampaignFromCurrentCampaignCustomerActive()) {
                    return;
                }

                // set initial info to make easier
                this.setInitialContactInfoFromCommunicationManager();

                // start
                this.isSwitchingCustomer = true;
            },
            switchCustomerForCampaignCustomerActive(customerID) {

                // Verify
                if (!this.validCampaignCustomerActiveID || !(customerID > 0)) {
                    return;
                }

                const options = {
                    call_id: (this.callId || 0),
                    customer_id: customerID,
                    force:        true, // casl, unique events, marketing days
                    override_all: false,
                }

                // If inbound or if we have call + customer (manual mode) then override all
                // todo - do we need this.voiceMailRecordingId > 0?
                if (this.call?.direction === "inbound" || this.call?.customer_id > 0) {
                    options.override_all = true;
                }

                // Set bools
                this.isUpdatingCCActive = true;
                this.turnFullScreenOverlayOn?.();

                SwitchCustomerForCampaignCustomerActive(this.currentCampaignCustomer?.campaign_customer_active_id, options).then((response) => {

                    // On success, handle
                    if (response?.Data?.campaign_customer_active?.campaign_customer_active_id > 0) {
                        this.showSnackbar("green", "Successfully switched customers");
                        this.newEnrollmentSuccess(response.Data.campaign_customer_active, true);
                        this.softReload();
                        this.stopSwitchCustomer();
                    } else if (response?.Error === "Unable to set next attemptable" || response.Error === "Customer does not have a valid phone number") {
                        this.showSnackbar("error", "The customer does not have any dialable phone numbers on profile.");
                    } else {
                        this.showSnackbar("error", "An error occurred while switching customers");
                    }
                }).catch((err) => {
                    console.error("switch customer failed", err);
                    this.showSnackbar("error", "An error occurred while switching customers");
                }).finally(() => {
                    this.isUpdatingCCActive = false;
                    this.turnFullScreenOverlayOff?.();
                });
            },
            switchOrganizationForCampaignCustomerActive(organizationID) {

               // Verify
                if (!this.validCampaignCustomerActiveID || !(organizationID > 0)) {
                    return;
                }

                const options = {
                    call_id: (this.callId || 0),
                    organization_id: organizationID,
                    force: true, // casl, unique events, marketing days
                    override_all: false,
                }

                // If inbound or if we have call + customer (manual mode) then override all
                // todo - do we need this.voiceMailRecordingId > 0?
                if (this.call?.direction === "inbound" || this.call?.customer_id > 0) {
                    options.override_all = true;
                }

                // Set bools
                this.isUpdatingCCActive = true;
                this.turnFullScreenOverlayOn?.();

                SwitchOrganizationForCampaignCustomerActive(this.currentCampaignCustomer?.campaign_customer_active_id, options).then((response) => {

                    // On success, handle
                    if (response?.Data?.campaign_customer_active?.campaign_customer_active_id > 0) {
                        this.showSnackbar("green", "Successfully switched organizations");
                        this.newEnrollmentSuccess(response.Data.campaign_customer_active, true);
                        this.softReload();
                    } else {
                        this.showSnackbar("error", "An error occurred while switching organizations");
                    }
                }).catch((err) => {
                    console.error("switch organization failed", err);
                    this.showSnackbar("error", "An error occurred while switching organizations");
                }).finally(() => {
                    this.isUpdatingCCActive = false;
                    this.turnFullScreenOverlayOff?.();
                });
            },
            clearAutoAssistantRequestTimeout() {
                if (this.autoAssistantRequestTimeoutId) {
                    clearTimeout(this.autoAssistantRequestTimeoutId);
                    this.autoAssistantRequestTimeoutId = null;
                }
            },
            refreshLoggedInQueuesFromServer() {
                if (typeof this.getCommunicationCenter !== "function") {
                    return;
                }
                // Do not change navigation — this is only a Vuex sync for the empty-state gate.
                this.getCommunicationCenter(false);
            },
            queueFinalAutoAssistantRequest() {
                this.clearAutoAssistantRequestTimeout();
                this.autoAssistantRequestTimeoutId = setTimeout(() => {
                    this.autoAssistantRequestTimeoutId = null;
                    this.getAutoAssistantRequest();
                }, 20000);
            },
            switchCampaignForCampaignCustomerActive(newCampaignID) {
                if (!newCampaignID) {
                    return;
                }

                // Init
                const options = {
                    account_id: this.currentCampaignCustomer?.account_id,
                    call_id: this.callId,
                    new_campaign_id: newCampaignID,
                }

                // Set bools
                this.isUpdatingCCActive = true;
                this.turnFullScreenOverlayOn?.();

                SwitchCampaignForCampaignCustomerActive(this.currentCampaignCustomer?.campaign_customer_active_id, options).then((response) => {
                    // If the response's campaign customer active is different than the current record, set changes
                    if (response?.Data?.campaign_customer_active?.campaign_customer_active_id > 0 && response?.Data?.campaign_customer_active?.campaign_customer_active_id !== this.currentCampaignCustomer?.campaign_customer_active_id) {
                        this.showSnackbar("green", "Successfully switched campaigns");
                        this.newEnrollmentSuccess(response.Data.campaign_customer_active, true);
                        this.setCurrentCampaignFromCurrentCampaignCustomerActive();
                        this.softReload();
                    } else {
                        this.showSnackbar("error", "An error occurred while switching campaigns. This customer may not meet eligibiltiy criteria for that campaign.");
                    }
                }).catch((error) => {
                    console.error("switch campaign failed", error);
                    this.showSnackbar("error", "An error occurred while switching campaigns");
                }).finally(() => {
                    this.isUpdatingCCActive = false;
                    this.turnFullScreenOverlayOff?.();
                });
            },
            removeForceTransferDialog() {
                this.forceTransferDialog = null;
            },
            resetCurrentCampaignCustomerDefaults(enrollmentSkip) {
                this.communicationManager = null;
                this.initiateCreateCommunicationDisposition = false;
                this.isUpdatingCCActive = false;
                this.mainErrorAlert = {};

                // Enrollment skip
                if (!enrollmentSkip) {
                    this.autoAssistData = {};
                    this.isHandlingInboundCall = false;
                    this.clearStuckAcceptedCallTimeout();
                    this.call = null;
                    this.callFailed = false;
                    this.callTransfer = null;
                    this.carlieLiveHandoff = null;
                    this.dispositionNotes = null;
                    this.earlyCarlieAnalysisUpdate = null;
                    this.firstRequestSent = false;
                    this.forceCall = null;
                    this.forceConference = null;
                    this.forceEndCall = false;
                    this.forceStartNextDial = false;
                    this.forceWebRtcParticipant = null;
                    this.forceWebRtcSession = null;
                    this.initialAddress = null;
                    this.initialEmailAddress = null;
                    this.initialFirstName = null;
                    this.initialLastName = null;
                    this.initialPhoneNumber = null;
                    this.isOkayToCreateCommunicationDisposition = false;
                    this.selectedCampaignDisposition = null;
                    this.survey = null;
                    this.resetCampaignDispositionToSurvey();
                    this.resetSavedCommunicationDispositions();
                }
            },
            resetCampaignDispositionToSurvey() {
                this.campaignDispositionToSurvey = null;
            },
            resetSavedCommunicationDispositions() {
                this.savedCommunicationDispositions = [];
            },
            resyncScreenForInternetLoss() {
                if (this.isBusyWithLiveOrAcceptingCall()) {
                    this.verifyCurrentAgent(true);

                    if (this.validCampaignCustomerActiveID) {
                        this.softReload();
                    }

                    if (this.hasAutoAssistData && !this.validAutoAssistData) {
                        this.getAutoAssistantRequest();
                    }
                    return;
                }

                const needsGetNext = this.renderNoCurrentCustomer === true || this.isCurrentAgentStatusPossibleSuspicious();

                if (needsGetNext) {
                    this.verifyCurrentAgent(false);
                    this.getNext(null);
                    return;
                }

                this.verifyCurrentAgent(true);
                this.assignReadyCampaignCustomers(this.getNextChainId, true);
            },
            setCall(call) {
                this.call = call;
            },
            setCampaignDispositions(campaignDispositions) {
                this.campaignDispositions = campaignDispositions;
            },
            setChangeOnCurrentCampaignCustomer(key, value) {
                switch(key) {
                case "total_communication_dispositions":
                    applyIncomingTotalCommunicationDispositions(this.currentCampaignCustomer, value);
                }
            },
            setCommunicationManager(communicationManager) {
                this.communicationManager = communicationManager;
                this.isCommunicationManagerSet = true;
            },
            setIsOkayToCreateCommunicationDisposition(isOkayToCreateCommunicationDisposition) {
                this.isOkayToCreateCommunicationDisposition = isOkayToCreateCommunicationDisposition === true ? true : false;
            },
            setIsOkayToSaveAndNext(isOkayToSaveAndNext) {
                this.isOkayToSaveAndNext = isOkayToSaveAndNext === true ? true : false;
            },
            setIsOkayToSurveySavedDisposition(isOkayToSurveySavedDisposition) {
                this.isOkayToSurveySavedDisposition = isOkayToSurveySavedDisposition === true ? true : false;
            },
            setOnCall(onCall) {
                const wasOnCall = this.onCall;
                this.onCall = onCall === true ? true : false;
                // Common post-disposition race: getNext ran while onCall was still true.
                if (wasOnCall && !this.onCall) {
                    this.flushGetNextPending();
                    Vue.nextTick(() => {
                        this.flushQueuedOffers();
                    });
                }
            },
            setCallFailed(isFailed) {
                this.callFailed = isFailed === true ? true : false;
            },
            setSelectedCampaignDisposition(campaignDisposition) {
                this.selectedCampaignDisposition = campaignDisposition;
            },
            setSurvey(survey) {
                this.survey = survey;
            },
            softReload() { // for causing the non-softphone components to reload
                this.isSoftReloading = true;

                // Turn off on next tick
                Vue.nextTick(() => {
                    this.isSoftReloading = false;
                });
            },
            startForceStartNextDial() {
                this.forceStartNextDial = true;
            },
            startVoiceMailRecording() {

                // Verify
                if (!this.voiceMailRecordingId) {
                    return;
                }

                // The immediate voiceMailRecordingId watcher and executeRemainingCreatedActions both
                // start the same recording on mount. Two responses each overwrite currentCampaignCustomer,
                // which strands the disposition panel on a replaced campaign customer (VE-10724).
                if (this.isStartingVoiceMailRecording) {
                    return;
                }
                this.isStartingVoiceMailRecording = true;

                // Missed-call getNext finishes after this request — keep watchdog alive for the wait.
                if (this.getNextInFlight) {
                    this.armGetNextInFlightTimeout(this.getNextChainId);
                }

                this.isLoading = true;
                StartVoiceMailRecording(this.voiceMailRecordingId).then((response) => {

                    if (response?.Data?.voice_mail_recording?.voice_mail_recording_id > 0) {

                        // Set vmr
                        this.voiceMailRecording = response?.Data?.voice_mail_recording;

                        // Set assigned campaign customer
                        this.currentCampaignCustomer = response?.Data?.assigned_campaign_customer;

                        // Set current campaign
                        this.currentCampaign = {
                            account_id: this.currentCampaignCustomer?.account_id,
                            campaign_id: this.currentCampaignCustomer?.campaign_id,
                            organization_id: this.currentCampaignCustomer?.organization_id,
                            organization_time_zone_id: null,
                            campaign_name: this.currentCampaignCustomer?.campaign_name,
                            organization_name: this.currentCampaignCustomer?.organization_name,
                        }

                        // If we have a cc active, move to in progress
                        // In case of unmatched customer, we will not have a cc yet
                        if (this.currentCampaignCustomer?.campaign_customer_active_id > 0) {
                            this.updateCampaignCustomerActive({ account_id: this.currentCampaignCustomer?.account_id, campaign_customer_active_id: this.currentCampaignCustomer?.campaign_customer_active_id, status: "in_progress" }, false);
                        } else {

                            // auto search for customers based on phone number
                            this.initialPhoneNumber = this.voiceMailRecording?.from_number;
                        }

                        // Resize window
                        Vue.nextTick(() => {
                            this.handleWindowResize();
                        });
                        this.finishGetNextChain();
                    } else if (this.missedCallFromCallScreen) {
                        // If we failed to start the vmr,
                        this.getNext("assignNextMissedCall");
                    }

                    this.isLoading = false;
                    this.isStartingVoiceMailRecording = false;
                }).catch(() => {
                    this.isLoading = false;
                    this.isStartingVoiceMailRecording = false;
                });
            },
            syncDispositionNotes(notes) {
                this.dispositionNotes = notes;
            },
            unassignCampaignCustomerActive(queuedFifteenMinutes) {

                // Init options
                const options = {
                    campaign_customer_active_id: this.currentCampaignCustomer?.campaign_customer_active_id,
                    account_id: this.currentCampaignCustomer?.account_id,
                    queued_fifteen_minutes: queuedFifteenMinutes === true,
                    status: "queued",
                }

                // Update record in db
                this.updateCampaignCustomerActive(options, false);
            },
            updateAutoAssistantRequest(customerId) {
                console.debug(this.autoAssistData)

                if (customerId <= 0 || this.autoAssistData?.id <= 0) {
                    return;
                }

                const options = {
                    customer_id: customerId
                }

                UpdateAutoAssistantRequest(this.autoAssistData.id, options).then((response) => {
                    if (response?.Data?.ok === true) {
                        console.debug("successfully updated auto assistant request customer id")
                    }
                })
                return;
            },
            updateCampaignCustomerActive(options, skipLoading) {

                // Load only if necessary
                if (!skipLoading) {
                    this.isLoading = true;
                }

                this.isUpdatingCCActive = true;

                // Capture before the request so handleAfter's getNext(null) (bumps chainId) is not finished by the tail.
                const chainId = this.getNextChainId;

                UpdateCampaignCustomerActive(options).then((response) => {

                    // If the response's campaign customer active matches the current record, set changes
                    if (response?.Data?.campaign_customer_active?.id > 0 && response?.Data?.campaign_customer_active?.id === this.currentCampaignCustomer?.campaign_customer_active_id) {
                        this.currentCampaignCustomer.status = response.Data.campaign_customer_active.status;

                        // Switch over status
                        switch(this.currentCampaignCustomer.status) {

                        // If this record is now in progress, loop through other records and set back to assigned
                        case "in_progress":

                            // If we already have a call, we don't want to move agent to start cc
                            // Use case: inbound call where they enroll a new cc
                            if (!this.callId) {
                                this.createAgentForStartCampaignCustomer();
                            }
                            this.ensureOtherCampaignCustomersBackToAssigned();
                            break;

                        // If the record is now queued, record was "saved for later", null current and rerun assign ready cc
                        case "queued":
                            // this.createAgentForSavedForLater();
                            this.handleAfterCampaignCustomerActive(this.currentCampaignCustomer.campaign_customer_active_id);
                            break;
                        }
                    } else if (response?.Error?.length > 0 && response?.Error === "Unable to find resource campaign customer active") {

                        // If we are unable to find cc active, then the agent is likely "stuck" -- so we need to intervene and get them to a new customer
                        // Handle after will remove the customer from this agent's "stack" and run get next
                        // Only do this if we are not forcing for inbound, if its an inbound call and we tried to update to inprogress but couldn't for whatever reason,
                        // don't run get next again, just let the agent remain on the call. 
                        if (!options.force_for_inbound) {
                            this.handleAfterCampaignCustomerActive(this.currentCampaignCustomer?.campaign_customer_active_id);
                        }
                    }

                    this.isLoading = false;
                    this.isUpdatingCCActive = false;
                    // Finish the chain that owned this update; skip if handleAfter already started a new one.
                    if (this.getNextInFlight && chainId === this.getNextChainId) {
                        this.finishGetNextChain();
                    }
                }).catch(() => {
                    this.isLoading = false;
                    this.isUpdatingCCActive = false;
                    // Unlock a hung get-next chain and retry when safe.
                    if (this.getNextInFlight && chainId === this.getNextChainId) {
                        this.queueGetNext();
                        this.finishGetNextChain();
                    }
                });
            },
            verifyCurrentAgent(refresh) {

                // Init option
                const options = {
                    agent_id: (this.currentAgent?.agent_id || 0),
                }

                if (refresh === true) {
                    options.refresh = true;
                }

                // Init previous status (in case the status changes while this request is running)
                const previousStatusName = (this.currentAgent?.agent_status_name || "");

                // Check current status to see if it matches the backend
                VerifyCurrentAgent((this.currentUser?.user_id || 0), options).then((response) => {

                    // If we do not have an error, continue on
                    if (response.Error === null) {

                        // If ok is false, then the agent ID passed to the server is not current...which means that the current user is out of sync
                        if (response?.Data?.ok !== true) {

                            // For V1, just move user back to the queue selection if prev was "Available"/"Offering Call"
                            if ((previousStatusName === "Available" || previousStatusName === "Offering Call") && this.goToQueueSelection !== undefined && this.goToQueueSelection !== null) {
                                this.goToQueueSelection();
                            }
                        } else {

                            // At this point, we know that the agent is still in the same status as before but we should still send them back for offering call
                            // since they have now missed the call and the backend clock job would have requeued the call for another agent
                            if (previousStatusName === "Offering Call" && this.goToQueueSelection !== undefined && this.goToQueueSelection !== null) {
                                this.goToQueueSelection();
                            }
                        }
                    }
                });
            },
            executeRemainingCreatedActions() {
                // If vmr, move to in progress and build screen
                if (this.voiceMailRecordingId > 0) {
                    this.startVoiceMailRecording();
                } else if (!this.validForceCustomer && !this.isManualMode) {
                    // Start process
                    this.getNext(null);
                }

                // If its a supervisor call, set everything needed
                if (this.isSupervisor) {
                    this.initiateSupervisorCall();
                }
            },
        },
        computed: {
            // Live accept: device connected, wrap-up, or a matched customer. forceCall is not proof —
            // accept hydration copies the offer's call even when the caller dropped.
            acceptedCallHasLiveProof() {
                if (this.onCall) {
                    return true;
                }
                if (this.validCampaignCustomerActiveID) {
                    return true;
                }
                const statusName = this.currentAgent?.agent_status_name;
                if (statusName === "Incoming Call" || statusName === "Outgoing Call" || this.isWrapUpBlockingDial) {
                    return true;
                }
                return false;
            },
            callId() {
                return this.call?.id;
            },
            currentAgent() {
                return VolieState.currentAgent();
            },
            currentAgentTimer() {
                return VolieState.currentAgentTimer();
            },
            currentUser() {
                return VolieState.currentUser();
            },
            hasAutoAssistData() {
                return this.currentCampaignCustomer?.incoming_phone_number?.receives_from_auto_assistant === true && this.callId > 0 && this.call?.direction === "inbound";
            },
            isInboundEligible() {
                return this.currentUser?.account_user?.is_inbound_eligible === true;
            },
            isMissedCallEnabled() {
                return this.currentUser?.account?.get_next_missed_calls === true;
            },
            isOutboundEligible() {
                return this.currentUser?.account_user?.is_outbound_eligible === true;
            },
            isPausedVoiceMailRecording() {
                return !this.validVoiceMailRecording && this.voiceMailRecordingId > 0;
            },
            isSupervisor() {
                return this.isBarge || this.isListen || this.isCoach || this.isLiveDashInboundCall
            },
            // VE-10377: while wrapping, do not auto-dial (fail-safe: do not dial).
            isWrapUpBlockingDial() {
                return WRAP_UP_AGENT_STATUSES.indexOf(this.currentAgent?.agent_status_name) >= 0;
            },
            manualModeInbound() {
                return this.currentUser?.account?.manual_mode_inbound === true;
            },
            renderCallScreen() {
                return !this.forceDestroy;
            },
            renderNoCurrentCustomer() {

                // If loading, do not render
                if (this.isLoading) {
                    return false;
                }

                if (this.isSupervisor) {
                    return false;
                }

                // If manual mode or inbound call but missing campaign ID, render.
                // Otherwise render if missing cc active ID.
                // isHandlingInboundCall keeps an accepted call on screen while its customer is still unmatched.
                return (this.isHandlingInboundCall || this.isManualMode || this.validPendingIncomingCall || this.validPendingCallTransfer || this.validVoiceMailRecording || this.validPendingSavedPlaceCall) ? !this.validCampaignID : !this.validCampaignCustomerActiveID;
            },
            renderNoLoggedInQueues() {
                return !this.hasLoggedInQueues && !this.validVoiceMailRecording && !this.validForceCustomer && !this.validCallId;
            },
            userDomInteraction() {
                return VolieState.userDomInteraction();
            },
            validAutoAssistData() {
                return this.autoAssistData?.auto_assistant_type != "" && this.autoAssistData?.event_body?.length > 0
            },
            validCallId() {
                return this.call?.id > 0;
            },
            validCampaignCustomerActiveID() {
                return this.currentCampaignCustomer?.campaign_customer_active_id > 0;
            },
            validCampaignID() {
                return this.currentCampaignCustomer?.campaign_id > 0;
            },
            validEndForceCustomer() {
                return this.endForceCustomer !== undefined && this.endForceCustomer !== null;
            },
            validForceCampaignCustomer() {
                if (this.isCallWithoutCustomer) {
                    return true;
                } else {
                    return this.forceCampaignCustomer?.campaign_customer_active_id > 0;
                }
            },
            validForceCustomer() {
                return this.forceCustomer?.customer_id > 0;
            },
            validPendingSavedPlaceCall() {
                return this.pendingSavedPlaceCall?.scheduled_communication_id > 0;
            },
            validPendingIncomingCall() {
                return this.pendingIncomingCall?.call_communication_queue?.call_communication_queue_id > 0;
            },
            validPendingCallTransfer() {
                return this.pendingCallTransfer?.call_transfer?.id > 0;
            },
            vinLoginDecisionPending() {
                return this.isVinEnabled && this.currentUser?.vin_login_enforcement?.requires_decision === true;
            },
            validVoiceMailRecording() {
                return this.voiceMailRecording?.voice_mail_recording_id > 0;
            },
        },
        components: {
            AcceptCallTransferDialog,
            AcceptIncomingCallDialog,
            AcceptSavedPlaceDialog,
            CustomerProfile,
            CustomerSearchCreate,
            IncomingDetails,
            NoCurrentCustomer,
            NoLoggedInQueues,
            Softphone,
            Survey,
        },
        props: {
            archiveMissedCallClicked: Boolean,
            audioEmailIncoming: HTMLAudioElement,
            audioEmailOutcoming: HTMLAudioElement,
            audioPhoneDeviceConnect: HTMLAudioElement,
            audioPhoneDeviceDtmf0: HTMLAudioElement,
            audioPhoneDeviceDtmf1: HTMLAudioElement,
            audioPhoneDeviceDtmf2: HTMLAudioElement,
            audioPhoneDeviceDtmf3: HTMLAudioElement,
            audioPhoneDeviceDtmf4: HTMLAudioElement,
            audioPhoneDeviceDtmf5: HTMLAudioElement,
            audioPhoneDeviceDtmf6: HTMLAudioElement,
            audioPhoneDeviceDtmf7: HTMLAudioElement,
            audioPhoneDeviceDtmf8: HTMLAudioElement,
            audioPhoneDeviceDtmf9: HTMLAudioElement,
            audioPhoneDeviceDtmfHash: HTMLAudioElement,
            audioPhoneDeviceDtmfStar: HTMLAudioElement,
            audioPhoneDeviceDisconnect: HTMLAudioElement,
            audioPhoneDeviceRinging: HTMLAudioElement,
            callsWaiting: Array,
            createAgent: Function,
            endForceCustomer: Function,
            endVoiceMailRecording: Function,
            exitForceCampaignCustomer: Function,
            endForceValidatedOutboundNumber: Function,
            forceCampaign: Object,
            forceCampaignCustomer: Object,
            forceCustomer: Object,
            forceEnrollAsEligible: Boolean,
            getCommunicationCenter: Function,
            goToQueueSelection: Function,
            hasLoggedInQueues: Boolean,
            isCallWithoutCustomer: Boolean,
            isLockedAgentStatus: Boolean,
            isRacOnline: Boolean,
            isWindowOnline: Boolean,
            isBarge: Boolean,
            isCoach: Boolean,
            isListen: Boolean,
            isLiveDashInboundCall: Boolean,
            isVinEnabled: Boolean,
            missedCallFromCallScreen: Boolean,
            organizationUsers: Array,
            parentForceCall: Object,
            parentForceWebRtcParticipant: Object,
            parentForceWebRtcSession: Object,
            resetArchiveMissedCallClicked: Function,
            resolveMykaarmaScreenPopEnabled: {
                type: Function,
                default: (_organizationId, serverEnabled) => serverEnabled === true,
            },
            setGetNextInFlight: Function,
            showSnackbar: Function,
            setVoiceMailRecordingId: Function,
            turnFullScreenOverlayOff: Function,
            turnFullScreenOverlayOn: Function,
            voiceMailRecordingId: Number,
            toggleFreezeAgentStatusPush: Function,
            freezeAgentStatusPush: Boolean,
            forceValidatedOutboundNumber: String,
            setForceValidatedOutboundNumber: Function,
        },
        destroyed() {
            this.getNextPending = false;
            this.clearSaveAndNextWrapUpSkip();
            this.clearAcceptInFlightTimeout();
            this.clearRecoverOfferingCallAcceptUISchedule();
            this.clearRecoverOfferingSavedPlaceCallAcceptUISchedule();
            this.clearStuckAcceptedCallTimeout();
            // Dialog open means the agent saw the offer. A queued hold never opened a dialog.
            if (this.acceptIncomingCallDialog === true) {
                this.declineIncomingCall(false);
            }
            if (this.acceptCallTransferDialog === true && this.validPendingCallTransfer) {
                this.declineCallTransfer(false);
            }
            if (this.acceptSavedPlaceDialog === true) {
                this.declineSavedPlaceCall(false);
            }
            this.clearQueuedPendingIncomingCall();
            this.clearQueuedPendingCallTransfer();
            this.clearQueuedPendingSavedPlaceCall();
            // VE-10320: keep parent latch if Available mint is still outstanding; mint.finally clears it.
            this.finishGetNextChain({
                skipFlush: true,
                skipParentClear: this.getNextAvailableMintPending === true,
            });
            this.clearAutoAssistantRequestTimeout();
            window.removeEventListener('resize', this.debouncedHandleWindowResize);
            window.removeEventListener('unload', this.handleWindowClosed);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "newAssignedCampaignCustomer" }}, this.onNewAssignedCampaignCustomer);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "assignedCampaignCustomerRefresh" }}, this.onAssignedCampaignCustomerRefresh);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "callCommunicationQueueUpdate" }}, this.onCallCommunicationQueueUpdate);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "callTransferUpdate" }}, this.onCallTransferUpdate);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "carlieAnalysisUpdate" }}, this.onCarlieAnalysisUpdate);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "newCommunicationDisposition" }}, this.onNewCommunicationDisposition);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "pushInboundCallToUser" }}, this.onPushInboundCallToUser);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "pushInternalCallTransferToUser" }}, this.onPushInternalCallTransferToUser);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "pushSavedPlaceCallToUser" }}, this.onPushSavedPlaceCallToUser);
            this.bus.unsubscribe({ type: "broadcast" , channel: { ID: null, Type: "autoAssistantEventNew" }}, this.onAutoAssistantEventNew);
        },
        created() {
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "newAssignedCampaignCustomer" }}, this.onNewAssignedCampaignCustomer);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "assignedCampaignCustomerRefresh" }}, this.onAssignedCampaignCustomerRefresh);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "callCommunicationQueueUpdate" }}, this.onCallCommunicationQueueUpdate);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "callTransferUpdate" }}, this.onCallTransferUpdate);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "carlieAnalysisUpdate" }}, this.onCarlieAnalysisUpdate);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "newCommunicationDisposition" }}, this.onNewCommunicationDisposition);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "pushInboundCallToUser" }}, this.onPushInboundCallToUser);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "pushInternalCallTransferToUser" }}, this.onPushInternalCallTransferToUser);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "pushSavedPlaceCallToUser" }}, this.onPushSavedPlaceCallToUser);
            this.bus.subscribe({ type: "broadcast" , channel: { ID: null, Type: "autoAssistantEventNew" }}, this.onAutoAssistantEventNew);
            this.initMainErrorAlert();
            this.debouncedHandleWindowResize = debounce(() => this.handleWindowResize(), 100);

            this.executeRemainingCreatedActions();
        },
        mounted() {
            window.addEventListener('resize', this.debouncedHandleWindowResize);
            window.addEventListener('unload', this.handleWindowClosed);
            this.handleWindowResize();
        },
        watch: {
            acceptedCallHasLiveProof(hydrated) {
                if (hydrated) {
                    this.clearStuckAcceptedCallTimeout();
                }
            },
            archiveMissedCallClicked: {
                immediate: true,
                handler(newVal, oldVal) {
                    if (newVal === true && oldVal === false) {
                        // Set current back to null
                        this.currentCampaign = null;
                        this.currentCampaignCustomer = null;
                        this.voiceMailRecording = null;
                        this.pendingSavedPlaceCall = null;
                        this.isSavedPlaceCall = false;
                        this.finishGetNextChain();
                        this.getNext(null);
                        this.resetArchiveMissedCallClicked();
                    }
                },
            },
            currentAgent: {
                immediate: true,
                handler(agent, previousAgent) {
                    this.trackIntendedNonProductionFromAgent(agent);

                    // VE-9959: Finished often lands after getNext already raced Wrap Up and ended without Available.
                    // Re-arm when we enter a stuck production idle status with no customer.
                    const statusName = agent?.agent_status_name;
                    const previousStatusName = previousAgent?.agent_status_name;
                    if (!statusName || statusName === previousStatusName) {
                        return;
                    }
                    if (statusName !== "Offering Call") {
                        this.clearRecoverOfferingCallAcceptUISchedule();
                    }
                    if (statusName !== "Offering Saved Place Call") {
                        this.clearRecoverOfferingSavedPlaceCallAcceptUISchedule();
                    }
                    if (statusName === "Finished CampaignCustomer" || statusName === "SMS Message - Processed Customer") {
                        this.recoverGetNextAfterStuckProductionStatus();
                    } else if (statusName === "Offering Call") {
                        // Debounce so push / assign-next response can open the dialog first.
                        this.scheduleRecoverOfferingCallAcceptUI();
                    } else if (statusName === "Offering Saved Place Call") {
                        this.scheduleRecoverOfferingSavedPlaceCallAcceptUI();
                    } else if (WRAP_UP_AGENT_STATUSES.indexOf(previousStatusName) >= 0) {
                        // Leaving wrap-up should flush any Available refusal queued above.
                        // VE-10377: bump dial-intent retry only for dial-safe statuses (fail-safe: do not dial).
                        Vue.nextTick(() => {
                            this.flushGetNextPending();
                            this.flushQueuedOffers();
                            if (
                                statusName === "Available" ||
                                statusName === "Start CampaignCustomer" ||
                                statusName === "Resume"
                            ) {
                                this.retryDialIntentToken++;
                            }
                        });
                    }
                },
            },
            // VE-9959: store VerifyCurrentAgent alone does not get-next; mirror the 30s suspicious timer here.
            currentAgentTimer(timer) {
                if (!(timer >= 30) || timer % 30 !== 0) {
                    return;
                }
                const statusName = this.currentAgent?.agent_status_name;
                if (statusName === "Finished CampaignCustomer" || statusName === "SMS Message - Processed Customer") {
                    this.recoverGetNextAfterStuckProductionStatus();
                } else if (statusName === "Offering Call") {
                    this.recoverOfferingCallAcceptUI();
                } else if (statusName === "Offering Saved Place Call") {
                    this.recoverOfferingSavedPlaceCallAcceptUI();
                } else {
                    this.recoverAfterStuckAcceptedCall();
                }
            },
            //This watcher is used to check the value logged in queues, if the value for from false to true
            //Like in the even that a user clocks "Log in All Queues" then quickly goes to the call screen, 
            //This will initiate get next once we get the websocket push on currentUser.account_user.has_logged_in_queues is set to true
            hasLoggedInQueues: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (oldValue !== newValue && newValue === true && oldValue === false && !this.validForceCampaignCustomer) {
                        //Clear the error that gets set on created so it doesn't get displayed that we are not logged into any queues
                        this.initMainErrorAlert();
                        //Execute the remaining actions to get the next call
                        this.executeRemainingCreatedActions();
                    }
                },
            },
            // Vuex can stay false after login if the RAC push is missed, or if the flag
            // was computed while campaigns were outside dial hours. Re-read once from the
            // server when this blocking screen appears (do not poll GetCommunicationCenter).
            renderNoLoggedInQueues: {
                immediate: true,
                handler(show) {
                    if (!show) {
                        return;
                    }
                    this.refreshLoggedInQueuesFromServer();
                },
            },
            call: {
                deep: true,
                immediate: true,
                handler() {
                    // Once we have a valid call Id, if its an ai transfer, set up fetches
                    if (this.hasAutoAssistData && this.validCallId) {
                        this.getAutoAssistantRequest();
                    }
                }
            },
            campaignDispositions: {
                deep: true,
                immediate: true,
                handler() {
                    this.buildCampaignDispositionPriorities();
                },
            },
            currentCampaignCustomer: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.currentCampaignCustomer === null) {
                        this.forceDestroy = true; // force cc dependent components to destroy
                        return;
                    }

                    // If they enroll a different customer than we had already set on the request record, send update to change customer id
                    if (this.hasAutoAssistData && this.currentCampaignCustomer.customer_id > 0 && this.currentCampaignCustomer.customer_id !== this.autoAssistData.customer_id) {

                        // Change state so we don't hit this multiple times
                        this.autoAssistData.customer_id = this.currentCampaignCustomer.customer_id;

                        // Send update
                        this.updateAutoAssistantRequest(this.autoAssistData.customer_id);
                    }
                },
            },
            forceCampaign: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.forceCampaign?.campaign_id > 0) {
                        this.enterManualMode({ ...this.forceCampaign }, null, this.forceEnrollAsEligible === true, null, this.forceValidatedOutboundNumber);
                    }
                },
            },
            forceDestroy: {
                immediate: true,
                handler() {
                    if (this.forceDestroy === true) {
                        Vue.nextTick(() => { this.forceDestroy = false; });
                    }
                },
            },
            isLoading() {
                Vue.nextTick(() => { this.debouncedHandleWindowResize(); });
            },

            isRacOnline() {

                // If it changed and now is true again, need to re-sync screen
                if (this.isRacOnline === true) {
                    this.resyncScreenForInternetLoss()
                }
            },
            isWindowOnline() {

                // If it changed and now is true again, need to re-sync screen
                if (this.isWindowOnline === true) {
                    this.resyncScreenForInternetLoss()
                }
            },
            voiceMailRecordingId: {
                immediate: true,
                handler(newVal, oldVal) {
                    if (oldVal !== newVal && newVal > 0) {
                        this.startVoiceMailRecording();
                    }
                },
            },
        },
    });
</script>

<style lang="scss" scoped>
</style>
